import "../assets/mapSvg.css";
import { useNavigate } from "react-router-dom";
const SvgComponent = () => {
  const navigate = useNavigate();
  const handleClickRegion = (region: string) =>
    navigate("/auctions", { state: { params: { region: region } } });
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 645.7 466.5"
      style={{ background: "0 0 645.7 466.5" }}
      xmlSpace="preserve"
    >
      <style type="text/css"></style>
      <g id="BACKGROUND">
        <polygon className="st0" points="-69.9,478.8 -69.9,478.8 -69.9,478." />
      </g>
      <g>
        <g>
          <path
            className="st1"
            d="M331.3,368.1c-0.3,0-0.6-0.1-1-0.3l-15.1-4.5c0,0-0.1,0-0.1,0l-8.9-3.7c-0.4-0.2-0.7-0.5-0.9-1l-2.7-9.3
    l-3.3-6l-8.3-14.5l-6.4-10.7c-2-0.8-9.9-3.8-14.6-3.8c-0.3,0-0.6,0-0.9,0l-6.9,9c-0.3,0.4-0.7,0.6-1.2,0.6c-0.2,0-0.4,0-0.6-0.1
    l-18.4-8.9c-0.5-0.2-0.8-0.8-0.8-1.3v-14.3l-8.2-5c-0.1-0.1-0.3-0.2-0.4-0.3l-8-10.1l-17.3-3.2l-5.7,3.1c-0.2,0.1-0.5,0.2-0.7,0.2
    h-25.6c-0.3,0-0.6-0.1-0.8-0.2l-42-28.2l-26.9-2.7c-0.8-0.1-1.3-0.7-1.3-1.5c0-1.1-0.4-3.4-0.6-5.1c-0.1-0.6-0.2-1.1-0.2-1.5
    c-0.2-1.7-0.5-3.6-1.2-5.2c-1.5-3.6-3.4-5.2-7.5-6.4c-0.7-0.2-1.2-0.9-1.1-1.6c0.2-2,0.2-2-1.6-2.7c-3.2-1.2-4-2.4-5.3-5
    c-1.2-2.4-5.4-3.2-8.5-3.7l-0.8-0.1c-1.4-0.2-2.9-0.6-3.6-1.8c-0.5-0.8-0.6-1.9-0.3-3.1c0.2-0.6,0.3-1.2,0.5-1.8
    c0.4-1.3,0.7-2.5,0.7-4c0-4.3-2.4-7.9-4.9-11.6c-2.7-4.1-5.5-8.3-5.3-13.7c0-0.4,0.2-0.9,0.6-1.1c0.3-0.2,0.6-0.3,0.9-0.3
    c0.1,0,0.2,0,0.3,0c0.5,0.1,1,0.2,1.5,0.2c0.7,0,1.1-0.2,1.1-0.2c0,0,0-0.1-0.1-0.4c-0.1-0.3-0.9-0.7-1.6-1
    c-1.1-0.5-2.3-1.1-3-2.3c-1.1-2.1-0.8-4.7-0.5-7c0.2-1.3,0.3-2.6,0.2-3.5c-0.1-0.8-0.7-1.3-1.6-2.2c-0.3-0.3-0.6-0.5-0.9-0.8
    l-0.3-0.3c-0.6-0.6-1.3-1.2-0.8-2.4c0,0,0-0.1,0-0.4c0-0.2,0-0.5,0-0.8c0-0.5,0-1,0-1.4c-0.3-2.4-1.2-4.7-2-6.9
    c-0.6-1.6-1.2-3.2-1.6-4.8c-0.6-2.5,0.3-4.3,1-5.7c0.8-1.5,1.1-2.3,0.6-3.6c-0.2-0.5-0.8-1-1.3-1.5c-0.7-0.6-1.5-1.3-1.9-2.3
    c-0.4-1.1-0.4-5.3,0.3-6.5c0.5-0.9,1.3-1.4,2-1.8c0.6-0.3,1.1-0.7,1.4-1.2c0.8-1.2,1.6-2.7,2.3-4c0.4-0.7,0.7-1.4,1.1-2
    c0.2-0.4,0.4-0.7,0.6-1.1c0.8-1.4,1.4-2.4,1.3-3.8c-0.2-2.4,0-4.3,0.6-6.4l0-0.1c-0.7-1.6-1.6-3.7-1.6-5.5c0-1.3,0.3-2.7,0.7-3.9
    c0.2-0.9,0.5-1.7,0.5-2.4c0.3-2.9,2.3-5.1,4.1-7.2c1.1-1.2,2.2-2.4,2.8-3.7c1.9-3.6,3.2-7.3,4.5-11.2c0.9-2.5,1.8-5.1,2.9-7.7
    c0.4-0.8,0.8-1.7,1.2-2.5c0.6-1.3,1.3-2.5,1.6-3.7c0.3-1,0.4-2,0.6-3.1c0.1-1.1,0.3-2.2,0.6-3.4c0.3-1.2,0.8-2.3,1.3-3.4
    c0.6-1.4,1.2-2.8,1.4-4c0.1-0.8-0.1-1.5-0.4-2.3c-0.2-0.6-0.3-1.1-0.4-1.8c-0.2-1.2,0-2.1,0.2-3c0.1-0.5,0.2-0.9,0.2-1.4
    c0.2-2.9,0.2-5.2-0.2-7.3c-0.5-2.6,0-4.4,0.6-6.4c0.1-0.4,0.2-0.8,0.4-1.3c0.1-0.5,0.5-0.8,0.9-1c0.2-0.1,0.3-0.1,0.5-0.1
    c0.3,0,0.6,0.1,0.8,0.2c0.8,0.5,1.7,0.9,2.6,1.4c1.2,0.6,2.5,1.2,3.7,2.1c1.5,1.2,3,2.4,4.5,3.9c0.2,0.2,0.7,0.5,1.1,0.9
    c1.3,1,3,2.1,3.1,3.9c0.1,1.4-0.8,2.5-1.6,3.3c-0.2,0.3-0.6,0.7-0.8,1c0.7,0.5,2.2,1.4,2.8,1.7c0.4-0.1,0.9-0.3,1.2-0.7
    c0.4-0.4,0.6-0.9,0.6-1.3c0-0.6-0.1-1.2-0.2-1.8c-0.1-1.1-0.3-2.3-0.1-3.8c0.3-1.9,0.2-2.4-0.6-4c-0.8-1.5-1.2-4.1-1.1-5.9
    c0-0.4,0.3-0.8,0.6-1.1c0.3-0.2,0.6-0.3,0.9-0.3c0.1,0,0.2,0,0.3,0l99.2,21.7l54.4,6l42.9,3.8l53.4,1.3c0.6,0,1.1,0.4,1.3,0.9
    c0.7,1.8,2.9,2.3,5.1,2.8c1.1,0.3,2.2,0.6,3.3,1c0.4,0.2,0.7,0.4,1,0.5c0.1,0,0.1,0.1,0.1,0.1c0.2,0,0.7-0.2,0.9-0.2
    c1.3-0.4,2.6-0.8,3.5-1.2c0.2-0.1,0.4-0.1,0.6-0.1c0.5,0,1,0.3,1.3,0.7c0.6,1,3.6,2.9,4.9,3.1c0,0,0.1,0,0.1,0
    c0.4,0,0.9-0.2,1.3-0.3c0.6-0.2,1.3-0.4,1.9-0.4c0.1,0,0.3,0,0.4,0c1.4,0.2,2.3,1.2,3.1,2.1c0.3,0.4,0.7,0.7,0.9,0.9
    c0.6,0.3,1.2,0.5,2.1,0.5c0.7,0,1.5-0.1,2.3-0.2c0.8-0.1,1.6-0.2,2.4-0.2c0.4,0,0.8,0,1.2,0c2.1,0,4.3,0.2,6.5,0.3
    c0.9,0.1,1.7,0.1,2.6,0.2c0.4,0,0.8,0.2,1,0.5c0.3,0.3,0.4,0.7,0.4,1.1c-0.3,3.2-4.2,4.5-6.5,5.3c-0.3,0.1-0.5,0.2-0.7,0.2
    c-2,0.7-4.3,2.4-5.7,4.3c-0.4,0.5-0.7,1-1,1.4c-1.1,1.5-2.1,3-3.9,4.3c-0.4,0.3-0.8,0.6-1.3,0.9c-0.1,0.1-0.3,0.2-0.4,0.3
    c2.7-0.4,5.1-1.6,7.7-2.8c1.1-0.5,2.2-1,3.3-1.5c0.2-0.1,0.4-0.1,0.6-0.1c0.4,0,0.9,0.2,1.2,0.6c0.4,0.5,0.4,1.3,0,1.8
    c-0.1,0.2-0.3,0.4-0.3,0.5c0.5,0.1,1.4,0.1,1.9,0.1c0.6,0,1.2,0,1.6,0.1c0.5,0.1,0.9,0.1,1.1,0.2c0.1,0,0.1,0,0.2,0
    c0.2-0.1,0.6-0.3,0.8-0.4l0.7-0.3c1.4-0.7,2.6-1.3,4.2-1.7c0.4-0.1,0.8-0.2,1-0.2c0.8-0.2,0.8-0.2,1.4-0.8c0.4-0.5,0.8-1,1.2-1.5
    c0.6-0.9,1.3-1.7,2.1-2.5c2.1-2.1,5.3-4.9,8.6-5.3c0.1,0,0.1,0,0.2,0c0.7,0,1.3,0.5,1.5,1.1c0.7,2.9-1.7,4.3-3.3,5.3
    c-1.3,0.8-2,1.3-2.3,1.9c0.2,0,0.5,0,0.8,0c0.6,0,1.3,0,2,0.2c1.9,0.4,2.6,1.2,3.4,2.1c0.2,0.2,0.4,0.5,0.6,0.7
    c1.4,1.6,2.3,1.8,2.9,1.8c0.7,0,1.5-0.3,2.8-0.8c0.9-0.4,1.8-0.6,2.6-0.8c0.7-0.1,1.3-0.3,1.8-0.5c0.5-0.2,0.9-0.4,1.3-0.7
    c1.1-0.6,2.3-1.2,4-1.4c0.3,0,0.7,0,1.1,0c0.2,0,1.2,0,1.4,0c0.5,0,1.1,0,1.5-0.1c0.4-0.1,0.7-0.3,1.1-0.6c0.7-0.5,1.6-1.1,3-1.1
    c0.3,0,0.6,0,0.9,0.1c0.7,0.1,1.2,0.7,1.2,1.4l0,0.4c0.1,1.2,0.1,2.2,0.3,2.5c0.1,0.1,0.6,0.4,2.4,0.5c2,0.2,2.8,0.3,4.2,2
    c0.5,0.5,0.8,1.1,1.2,1.7c0.3,0.5,0.6,0.9,0.9,1.3c0.3,0.4,0.4,0.9,0.3,1.4s-0.5,0.8-1,1c-3,1-6.2,1.3-9.2,1.6
    c-2,0.2-3.9,0.4-5.8,0.8c-0.8,0.2-1.5,0.5-2.2,0.9c-0.5,0.2-1,0.5-1.5,0.7c-1.1,0.5-2.3,0.6-3.3,0.8c-0.7,0.1-1.5,0.2-2.1,0.4
    c-2.2,0.6-3.2,2.3-4.4,4.5c-0.4,0.7-0.8,1.4-1.3,2.2c-0.6,0.8-1,1.8-1.4,2.8c-0.1,0.1-0.1,0.3-0.2,0.4c0,0,0.1-0.1,0.1-0.1
    c0.2-0.3,0.4-0.6,0.7-0.9c1-1.4,2.2-3.1,4-3.4c0.1,0,0.2,0,0.3,0c0.3,0,0.7,0.1,0.9,0.3c0.3,0.3,0.5,0.7,0.6,1.1
    c0,1.4-0.5,2.9-0.9,4.4c-0.3,1-0.6,1.9-0.7,2.7c-0.3,1.9-0.8,3.4-1.3,4.8c-0.2,0.6-0.4,1.1-0.6,1.7c-0.4,1.2-0.3,2.8-0.2,4.3
    c0,0.6,0,1.2,0,1.8c0,1.6-0.2,3.2-0.5,4.7c-0.2,1.3-0.4,2.5-0.4,3.7c0,1.9,0.4,3.8,0.8,5.8c0.4,1.9,0.8,3.8,0.9,5.8
    c0,0.5,0.3,5.4,3.4,5.4c0.4,0,0.8-0.1,1.3-0.2c3.4-1,5.1-5.8,5.5-9.6c0-0.5,0.1-1,0.2-1.6c0.2-1.3,0.5-2.9,0.1-3.9
    c-0.2-0.7-0.9-1.3-1.7-2c-0.6-0.6-1.3-1.2-1.8-2c-1.4-2-1.1-3.6-0.8-5.2c0.1-0.3,0.1-0.6,0.2-1c0.2-1.4,0.2-2.8,0.2-4.3
    c0-0.5,0-0.9,0-1.4l0-0.8c0-1.9,0-3.8,0.7-5.9c0.1-0.3,0.3-0.8,0.4-1.4c0.6-2.2,1.2-3.7,2-4.6c0.1-0.1,0.1-0.1,0.2-0.2
    c0.3-0.3,0.7-0.9,1.7-1.1c0.1,0,0.2,0,0.3,0c0.4,0,0.8,0.2,1.1,0.5c0.2,0.2,0.4,0.5,0.6,0.7c0.3,0.4,0.6,0.7,0.9,1
    c0.1-0.6,0.2-1.2,0.3-1.8c0.3-2.3,0.8-5.7,3.7-6.6c0.4-2.6,2.3-3.2,4.3-3.4c0.4,0,0.8-0.1,1.2-0.1c2.2,0,3,1,3.9,2.1
    c0.2,0.2,0.4,0.5,0.6,0.8c1,1.2,2.5,1.4,4.3,1.7c2.6,0.4,6.1,0.9,6.6,6c0.1,1.6,0.1,3.2,0,4.8c0,0.6,0,1.2,0,1.8
    c0,3.2-0.9,3.9-3.2,5.3c-1.7,1.1-2,1.7-1.9,3.7c0,0.4,0,0.8,0.1,1c0.1-0.1,0.2-0.1,0.4-0.2c1.5-1,2.7-2.4,3.5-4
    c0.1-0.2,0.2-0.4,0.3-0.6c0.4-0.9,1.1-2.4,2.8-2.4c0.6,0,1.3,0.2,2.2,0.7c4.7,2.6,5.1,8.2,5.4,12.2l0.1,1.1c0,0.3,0,0.5,0.1,0.8
    c0.1,1.4,0.3,3.1-0.8,4.6c-0.4,0.5-0.7,0.9-1,1.2c-0.5,0.6-0.6,0.8-0.8,2c-0.2,1.4-0.6,2.9-1,4.3c-0.4,1.5-0.8,2.9-1,4.3
    c0.5,0.2,1,0.4,1.5,0.7c1.1,0.5,2.6,1.2,3.4,1.2c1.5-0.1,4.2-1.7,6.1-2.7c0.6-0.3,1.2-0.7,1.6-0.9c6.9-3.7,12.4-7.4,17.4-11.7
    c0.6-0.5,1.5-1.1,2.6-1.8c1.7-1.1,6.3-4.2,5.8-5.5c-0.2-0.6-0.5-0.9-0.9-1.2c-0.4-0.4-1.1-1-1.1-1.9c0-1,0.6-1.9,1.3-2.6
    c1.9-2.1,4.3-3.1,7.4-3.2c0.3,0,0.6,0,0.9,0c0.6,0,1.2,0,1.9,0c0.6,0,1.2,0,1.8,0c1.5,0,2.6-0.2,3.5-0.6c1.3-0.6,2.6-1.6,3.8-2.5
    c0.7-0.5,1.4-1.1,2.1-1.6c0.6-0.4,1.4-0.7,2.2-1c0.6-0.2,1.7-0.6,1.8-0.9c-0.1-0.4-0.8-2.3-1.1-3.3c-0.3-0.8-0.6-1.5-0.7-1.9
    c-0.1-0.4-0.3-1,0.2-1.6c0.2-0.2,0.4-0.4,0.6-0.5c0.6-1,1.3-2.2,2-3.5c2-3.7,4.2-8,7.2-9.4c1.5-0.7,3.4-1,5.2-1.3
    c1.3-0.2,2.5-0.4,3.5-0.8c2.1-0.7,4.2-1.3,6.2-1.9c2-0.6,4.1-1.2,6.1-1.8c1-0.3,2.1-0.6,3.1-0.8c1.9-0.4,3.8-0.9,5.2-1.8
    c2-1.3,3.7-2.9,5.4-5c0.6-0.7,1.1-1.2,1.6-1.7c0.6-0.6,1.1-1,1.5-1.8c0.9-1.7,1.6-3.7,1.9-5.6c0.4-2.3,0.5-4.6,0.6-7.1
    c0.1-2.2,0.2-4.4,0.5-6.6c0.2-1.8,0.5-4.1,1.1-6.2c0-0.1,0.1-0.3,0.1-0.4c0.1-0.7,0.3-2,1.7-2.7c0.5-0.2,0.9-0.3,1.3-0.3
    c0.9,0,1.4,0.5,1.6,0.8c0.1,0.1,0.1,0.1,0.2,0.2c0.5,0.2,1,0.3,1.4,0.3c0.8,0,1.5-0.3,2.6-0.7l0.5-0.2c0.9-0.4,1.7-0.5,2.4-0.5
    c1.5,0,2.5,0.8,3.5,1.7c0.3,0.2,0.6,0.5,0.9,0.8c3.7,3,4,6.5,4.2,10.3c0,0.8,0.1,1.6,0.2,2.4c0,0.4,0,0.8,0,1.4
    c0,0.6,0,2.2,0.3,2.5c0,0,0.1,0,0.2,0c0.2,0,0.5,0,0.8-0.1c0.4,0,0.7-0.1,1.1-0.1c0.7,0,1.4,0.2,1.9,0.5c1,0.7,1.3,2,1.5,3
    c0,0.3,0.1,0.7,0.2,0.8c0.2,0.1,0.6,0.3,1.2,0.3c0.5,0,1.1-0.1,1.7-0.2c0.1,0,0.3,0,0.4,0c0.5,0,1,0.2,1.3,0.7
    c1.1,1.7,1.5,3.4,1.1,5.1c-0.6,2.7-3.2,4.6-5.3,5.9c-0.5,0.3-0.9,0.5-1.2,0.7c-1.2,0.7-1.2,0.7-1.6,2.4c-0.5,2.1-2.1,4.1-4.6,4.1
    c-0.1,0-0.2,0-0.2,0c-1-0.1-1.7-0.4-2.2-0.8c-0.3,0.6-0.4,1.3-0.5,2.2c-0.1,0.8-0.2,1.8-0.5,2.7c-0.7,1.9-2.1,2.3-3,2.6
    c-0.5,0.2-0.8,0.3-1.2,0.6c-0.3,0.3-0.5,0.8-0.7,1.6c-0.2,0.8-0.5,1.9-1.3,2.8c-1.4,1.6-3.8,4.9-3.7,8.5c0,1.1,0.4,1.7,1,2.7
    c0.1,0.2,0.2,0.4,0.4,0.6c1,1.6,1,2.7,1.1,3.8c0,0.4,0,0.8,0.1,1.2c0.1,0.7,0.4,1.1,1.1,1.9c0.4,0.5,0.9,1,1.4,1.7
    c0.4,0.7,0.6,1.4,0.8,2c0.3,0.9,0.4,1.1,0.5,1.1c0.1,0,0.2-0.1,0.3-0.2c0.4-0.2,1-0.6,1.7-0.6c0.4,0,1.3,0.1,1.9,1.1
    c1,1.5-0.1,3-0.6,3.6l-0.1,0.2c-0.6,0.8-1.5,1.9-3.1,1.9c-0.4,0-0.8-0.1-1.1-0.1c-0.3,0-0.5-0.1-0.8-0.1c-0.1,0-0.2,0-0.3,0
    c0,0-0.1,0.1-0.1,0.1c-0.3,0.3-0.6,0.7-1.3,0.9c-0.4,0.2-1,0.2-1.5,0.3c-0.2,0-0.4,0-0.6,0.1c0,0.1-0.1,0.2-0.1,0.5
    c-0.1,0.5-0.3,1.2-0.9,1.9c-1.1,1.2-3.3,1.9-5.2,2.4c-0.6,0.2-1.3,0.4-1.7,0.5c-0.1,0-0.2,0.1-0.2,0.1c0.6,0.2,1.4,0.6,1.6,1.5
    c0.2,0.9-0.3,1.5-0.6,1.7c-0.1,0.1-0.2,0.2-0.2,0.3c-0.7,1.4-2.4,3.5-3.9,4.4l-0.8,0.5c-3.3,2.2-6.7,4.4-10.9,5l-0.5,0.1
    c-0.3,0-0.6,0.1-0.9,0.1c0,0,0,0,0,0c0,0.1,0.2,0.3,0.4,0.5c0.4,0.4,0.8,1,1,1.9c0.2,1.1,0,2-0.2,2.7c0,0.2-0.1,0.4-0.1,0.6
    c-0.8,4.1-2.3,7.8-4.1,12c-0.1,0.3-0.2,0.8-0.4,1.3c-0.4,1.6-0.7,2.6-1.4,3.3c-0.6,0.6-1.3,0.9-2.1,0.9c-0.4,0-0.9-0.1-1.2-0.3
    c0.4,0.6,0.9,1.2,1.5,1.9c0.8,1,1.7,1.9,2.2,3.1c0.7,1.6,0.6,2.5-0.4,3.5c-0.2,0.2-0.3,0.3-0.5,0.6c-0.7,1-0.7,1-0.6,2.4
    c0.1,1.9-0.3,3.5-0.7,5c-0.3,1.1-0.6,2.2-0.6,3.4c0,0.2,0,0.4,0,0.7c-0.1,2.4-0.2,7.4-3.8,7.4c-0.3,0-0.6,0-1-0.1
    c-0.5-0.1-0.9-0.5-1-0.9c-0.9-2.6,0-4.9,0.9-7c0.5-1.1,0.9-2.2,1-3.2c0-0.4,0-0.7,0-0.8c-0.2-0.1-0.4-0.1-0.7-0.2l-0.4-0.1
    c-0.3-0.1-0.5-0.2-0.8-0.3c-0.2-0.1-0.4-0.1-0.5-0.2c0,0.1-0.1,0.2-0.2,0.3c-0.8,1.6-0.9,5.1-0.7,7.7c0,0.5,0.1,1.1,0.1,1.8
    c0,0.7,0,1.7,0.1,2.1c0.1,0.3,0.4,0.8,0.8,1.2c0.3,0.4,0.6,0.8,0.9,1.2l1.9-0.1c0,0,0.1,0,0.1,0c0.6,0,1.2,0.4,1.4,1
    c0.2,0.5,0.4,1.1,0.7,1.7c1,2.3,2.1,4.9,1,7c-0.4,0.7-1,1.3-1.9,1.7c-0.1,0.7-0.3,1.2-0.6,1.6c0.5,0.1,1,0.3,1.5,0.7
    c0.6-0.6,1.3-1.2,2.2-1.2c1,0,1.8,0.6,2.4,1.7c1.4,2.3-0.1,4.4-1,5.6l-0.2,0.3c-0.2,0.3-0.5,0.8-0.7,1.4c-0.7,1.5-1.4,2.9-2.6,3.4
    c-0.4,0.2-0.8,0.2-1.2,0.2c-0.9,0-1.6-0.4-2.1-0.9c0.2,1.2-0.2,1.9-0.5,2.5c-0.1,0.2-0.2,0.3-0.2,0.4c0.4-0.2,0.9-0.5,1.2-0.7
    c1.1-0.7,2-1.3,2.9-1.3c0,0,0.1,0,0.2,0c0.7,0.1,1.3,0.7,1.4,1.4c0.3,5.7-2.5,7-6.7,7.2c-0.1,0-0.3,0-0.4,0c-0.2,0-0.5,0-0.8,0
    c-0.3,0-0.7,0-1.1,0c-0.9,0-1.3,0.1-1.4,0.1c-0.3,0.3-0.9,1.4-1.3,2c-0.3,0.6-0.6,1.2-0.9,1.6c-0.5,0.7-1.1,1.4-1.7,2
    c-0.5,0.6-1.1,1.1-1.4,1.6c-0.5,0.7-0.6,1.8-0.7,3.1l0,0.4c-0.3,2.7-1,4.5-3.9,4.5c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.7,0
    c-0.2,0-0.5,0-0.7,0c-0.8,1.9-2.2,3.8-3.7,5c-1.6,1.4-2,2.1-2.9,3.8c-0.9,1.8-2.5,3.3-3.9,4.7c-0.7,0.6-1.3,1.3-1.9,1.9
    c-1.9,2.1-3.7,4.3-5.5,6.5l-0.6,0.7c-0.5,0.6-0.9,1.1-1.4,1.6c-1,1-1.9,2-2.4,3.2c-0.6,1.3-0.8,2.7-1,4.3
    c-0.1,0.8-0.2,1.7-0.4,2.6c-0.1,0.8-0.3,1.5-0.5,2.3c-0.7,3.4-1.4,6.6-0.8,9.9c0.7,3.7,2.8,7.1,4.9,10.5c0.7,1.1,1.5,2.3,2.1,3.5
    c0.9,1.6,1.8,3.3,2.6,4.9c1,2.1,2.1,4.2,3.4,6.3l1.7,2.9l0.2,0.2c3.6,4.9,8.1,11,8.3,17.2c0.1,2,0.4,4,0.7,6
    c0.6,3.5,1.2,7.1,0.5,10.9c-0.1,0.5-0.2,0.9-0.3,1.4c-0.3,1.3-0.5,2.4-0.5,3.7l0,0.6c0,1.9,0,3.6-2.5,5.1
    c-2.3,1.4-4.1,2.4-5.4,2.4c0,0-0.1,0-0.2,0c-1.7-0.1-3.3-2-5.4-5l-0.1-0.1c-0.6-0.9-0.9-1.9-1.1-2.7c-0.2-0.7-0.3-1.2-0.6-1.6
    c-0.4-0.5-1-0.7-2.1-0.9c-0.7-0.2-1.5-0.4-2.3-0.8c-2.3-1.2-2.5-2.9-2.6-4.1c-0.1-0.6-0.1-1.1-0.4-1.6c-0.5-1.1-1-1.2-2.9-1.3
    l-0.4,0c-0.8,0-1.4-0.6-1.4-1.4c0-0.7,0-1.5,0-2.2c0-0.2,0-0.4,0-0.7c-2-0.6-3.2-2.9-4.2-4.8c-0.4-0.7-0.7-1.4-1-1.8
    s-0.5-0.6-0.8-0.9c-1-1.1-1.4-1.9-0.9-3.5c-0.2-0.1-0.5-0.2-0.7-0.4c-2.9-2.6-2.6-5.5-2.4-8.1c0.1-1.3,0.2-2.5,0-3.8
    c-0.6-3.1-2.5-4.3-5-6.1c-1-0.7-2.1-1.4-3.2-2.4c-0.9-0.8-1.8-1.8-2.7-2.7c-2-2.2-3.8-4.2-6.1-4.2c-0.3,0-0.6,0-0.9,0.1
    c-1.3,0.3-2.7,1.2-4,2.2c-0.9,0.6-1.9,1.3-2.8,1.8c-0.3,0.1-0.6,0.3-1,0.5c-0.8,0.4-1.6,1-2.5,1.2c-0.8,0.2-1.1,0.3-1.5,0.3
    c-0.7,0-1.2-0.4-1.4-0.6c-0.1-0.1-0.3-0.3-0.6-0.4l-0.5-0.3c-1.6-0.9-3.1-1.8-4.1-3.9c-0.3-0.5-0.4-1-0.4-1.3
    c-0.1-0.1-0.2-0.1-0.4-0.2c-0.8-0.4-2.1-0.7-3.2-0.8c-0.5,0.2-0.9,0.2-1.2,0.2c-0.8,0-2-0.2-3.1-0.4c-0.8-0.1-1.7-0.3-2-0.3
    c-1.2,0.1-2.4,0.3-3.7,0.5c-1.7,0.3-3.4,0.6-5.1,0.6c-0.4,0-0.8,0-1.2,0c-0.4,0-0.6,0-0.9,0c-0.5,0-0.6,0-1.3,0.4
    c-0.4,0.2-0.8,0.4-1.5,0.7c-1.5,0.6-3,0.7-4.2,0.7c-0.5,0-1.1,0-1.6,0c-0.5,0-1,0-1.5,0c-0.9,0-1.5,0.1-2.1,0.2
    c-1.9,0.4-3.7,1.3-5.5,2.2c-0.9,0.5-1.9,0.9-2.9,1.4c-1.3,0.5-1.3,0.5-1.2,2c0,0.3,0,0.7,0,1.2c0,0.4,0,0.9-0.1,1.4
    c-0.1,1-0.1,2.2,0.1,2.8c0.1,0.4,0.7,0.7,1.2,1c0.9,0.5,1.9,1.2,2.3,2.5c0.1,0.4,0,0.8-0.1,1.1c-0.2,0.3-0.5,0.6-0.9,0.7
    c-0.8,0.2-1.5,0.3-2.2,0.3c-2.1,0-3.9-0.9-5.3-2.7c-0.2-0.3-0.4-0.6-0.6-0.9c-0.5-0.7-0.8-1.1-1.1-1.3c0.1,1.4,0.2,3-1,3.9
    c-0.5,0.4-1.1,0.6-1.7,0.6c-0.8,0-1.6-0.3-2.3-0.6c-0.3-0.1-0.8-0.3-1-0.3c-0.5,0-0.8,0.2-1.5,0.6c-0.7,0.4-1.5,1-2.7,1.1
    c-0.1,0-0.3,0-0.4,0c-1.6,0-2.6-0.8-3.4-1.5c-0.2-0.2-0.4-0.3-0.6-0.5c-2-1.5-4.2-3.1-6.4-4c-0.1-0.1-0.3-0.1-0.5-0.2
    c-0.5-0.2-1.4-0.6-1.8-0.6c-0.2,0.1-0.6,0.5-0.9,0.8c-0.6,0.7-1.5,1.7-2.9,1.8c0,0-0.1,0-0.1,0c-0.1,0-0.3,0-0.4-0.1
    c-1.4-0.4-3-1.8-4-3l0,0c-0.8,0.1-1.6,0.3-2.3,0.4c-1.3,0.2-2.6,0.3-3.9,0.4c-5.5,0.5-11.1,1.1-15.2,4.4c-1,0.8-1.8,1.8-2.7,2.9
    c-1.3,1.6-2.6,3.2-4.5,4.2c-1,0.5-2,0.8-2.9,1c-0.7,0.2-1.4,0.3-2,0.6c-0.8,0.4-1.6,1.3-2.3,2.1c-0.3,0.3-0.5,0.6-0.8,0.9
    c-1.5,1.6-3.3,2.9-5,4c-1.4,1-2.7,1.9-3.8,3l-0.9,0.9c-2.5,2.3-5.4,4.9-7.1,7.6c-1,1.5-0.9,2.4-0.2,4.5c0.7,2.4,1.2,5.3,1.6,8
    c0.3,1.9,0.6,3.7,0.9,5.3c0.1,0.4,0.1,0.8,0,1.2C332.5,367.7,332,368.1,331.3,368.1z M579.7,131c-2.2,0.6-4.2,1.4-5.4,3.1
    c1.5-0.3,2.8-1.2,4.3-2.3C578.9,131.5,579.3,131.3,579.7,131z"
          />
        </g>
      </g>
      <g className="Pacific-states-hover">
        <path
          className="Pacific-states"
          onClick={() => handleClickRegion("Pacific States")}
          d="M135.2,124.6c-0.1-1.9,0.5-3.9,1.1-5.9c0.4-1.3,0.7-2.4,0.9-3.6c0.4-2.9,1.1-5.7,2.1-8.8
  c0.8-2.6,1.4-4.9,1.9-7.2c0.1-0.3,0.2-0.6,0.3-0.9c0.2-0.5,0.3-1,0.3-1.3c0-0.6-0.1-0.7-0.3-0.9c-0.1-0.1-0.3-0.3-0.5-0.7
  c-0.1-0.2-0.2-0.3-0.3-0.4c-0.3-0.3-0.7-0.7-0.5-1.7c0.1-0.8,1.1-1.8,2.1-2.6c0.5-0.5,1.1-1,1.3-1.3l0.5-0.7
  c1.1-1.6,2.1-3.2,3.4-4.7c0.3-0.3,0.5-0.6,0.9-0.9c1.1-1.1,2.4-2.4,2.2-3.8c-0.1-0.6-0.5-1.2-1-1.8c-0.5-0.7-1-1.4-1.2-2.2
  c-0.2-0.7-0.3-1.4-0.3-2.1c-2.2-0.5-4-1.3-6-2.1c-0.5-0.2-1.1-0.5-1.6-0.7c-2.4-1-5.8-1.3-8.8-1.5c-0.5,0-1.1-0.1-1.6-0.1
  c-1.5-0.1-2.9-0.2-4.4-0.2c-1.8-0.1-3.8-0.1-5.7-0.3c-2.3-0.3-4.3,0.2-6.6,0.8l-0.2,0.1c-2.6,0.7-4.8-0.3-6.8-1.2
  c-1.6-0.7-3.1-1.4-4.8-1.3c-0.5,0-1,0-1.5,0c-1.1,0-2.2,0.1-3.2,0c-0.2,0-0.4,0-0.6-0.1c-1.1-0.1-1.4-0.2-1.5-1.3
  c0-0.2-0.1-0.4-0.1-0.7c-0.1-0.8,0-1.8,0.1-2.9c0.2-1.4,0.3-2.9-0.2-3.7c-0.1-0.2-0.9-0.6-1.3-0.8c-0.4-0.2-0.7-0.4-1-0.6
  c-0.3-0.3-0.7-0.6-1.1-0.9c-0.5-0.4-1-0.9-1.4-1.2c-1.1-0.7-2.4-1-3.8-1.3c-0.7-0.1-1.3-0.3-1.9-0.5c-0.1,0.4-0.3,0.7-0.4,1.1
  c-0.6,2.2-0.5,4.4-1.2,6.5c-0.7,2.2-2,4.2-2.9,6.3c-2.7,6.4-4.2,12.9-7.5,19.1c-2,3.6-6.4,6.4-6.8,10.4c-0.2,2-1.3,4.2-1.2,6.2
  c0,1.5,0.8,3.4,1.5,5l0.4,0.1C66.4,107.4,98.1,116.1,135.2,124.6z"
        />
        <path
          className="Pacific-states"
          onClick={() => handleClickRegion("Pacific States")}
          d="M90.2,53.5c0.6,0.3,1.1,0.8,1.6,1.3c0.3,0.3,0.7,0.6,1,0.8c0.2,0.1,0.5,0.3,0.8,0.5c0.9,0.5,1.4,0.8,1.7,1.2
  c0.7,1.1,0.5,2.8,0.3,4.4c-0.1,1-0.2,1.9-0.1,2.6c0.1,0.3,0.1,0.5,0.1,0.7c0,0.1,0,0.3,0.1,0.3c0.1,0,0.3,0,0.5,0.1
  c0.2,0,0.4,0,0.6,0.1c1,0.1,2,0.1,3.1,0c0.5,0,1,0,1.5,0c1.9,0,3.6,0.7,5.2,1.4c2,0.9,3.9,1.7,6.2,1.1l0.2-0.1
  c2.3-0.6,4.4-1.1,6.9-0.8c1.9,0.2,3.8,0.3,5.6,0.3c1.4,0.1,2.9,0.1,4.4,0.2c0.5,0,1,0.1,1.6,0.1c3.1,0.2,6.6,0.4,9.1,1.5
  c0.6,0.2,1.1,0.5,1.6,0.7c1.9,0.8,3.5,1.5,5.5,2c0-1.6,0.2-3.3,0.6-5.1c1.4-5.6,2.7-11,3.9-16.3c0.4-1.7,0.7-3.4,0.9-5.1
  c0.4-2.5,0.8-5.1,1.6-7.6c0.2-0.7,0.5-1.4,0.8-2.2c0.3-0.7,0.5-1.4,0.8-2.1l-52.1-11.4c-0.2,1.5,0.3,3.9,0.9,5.1
  c1,1.9,1.1,2.8,0.8,4.9c-0.3,2,0.2,3.4,0.3,5.3c0.1,1.7-1.7,3.6-3.6,3.6c-0.2,0-3.9-2.1-4.1-2.5c-0.7-1.8,2.5-3.2,2.4-4.9
  c-0.1-1.5-2.8-2.8-3.8-3.8c-1.4-1.4-2.8-2.6-4.3-3.8c-1.9-1.5-4.3-2.1-6.2-3.4c-0.7,2.6-1.5,4.3-1,7.1c0.5,2.4,0.5,5.1,0.3,7.8
  c-0.1,1.5-0.6,2.6-0.4,4c0.2,1.5,1,2.8,0.8,4.5c-0.2,1.9-1.2,3.8-2,5.7c0.6,0.2,1.2,0.3,1.8,0.4C87.5,52.4,89,52.7,90.2,53.5z"
        />
        <path
          className="Pacific-states"
          onClick={() => handleClickRegion("Pacific States")}
          d="M135.5,252.9c0.1-0.3,0-0.9-0.4-1.6c-0.2-0.4-0.5-0.7-0.7-1c-0.7-0.9-1-1.6,0.2-2.8c1.3-1.4,1.8-2.6,2.5-4.4
  c0.1-0.3,0.2-0.6,0.3-0.8c0.5-1.4,1-2.8,2-4c0.3-0.3,0.5-0.6,0.8-0.9c0.7-0.8,1.5-1.6,2-2.5c0.5-0.9,0.4-1.1-0.1-1.7
  c-0.2-0.3-0.4-0.6-0.6-1.1c-0.4-0.9-0.4-1.8-0.4-2.8c0-0.4,0-0.7-0.1-1.1c-0.1-0.5-0.1-1.1-0.1-1.6c0-0.5,0-1-0.1-1.4l-47.1-68.7
  l0.1-0.2c4.4-13.9,10.9-34.8,11.2-37.7c-22.9-5.7-39.2-10.1-39.6-10.2h0c-0.6,2.1-0.8,3.8-0.6,5.9c0.2,2.3-1.1,3.8-2.1,5.8
  c-1.1,2.1-2.2,4.3-3.5,6.2c-1,1.5-2.7,1.7-3.4,2.9c-0.4,0.7-0.5,4.4-0.2,5.2c0.5,1.4,2.5,2.2,3.2,3.8c1.6,3.8-2.6,5.6-1.5,9.5
  c1,3.9,3.1,7.7,3.7,12c0.1,0.8,0,1.7,0,2.4c0,1.6-0.8,0.7,0.6,2c1.2,1.2,2.7,2,3,3.9c0.4,2.8-1.3,7.3,0.2,10.1
  c0.9,1.7,4.2,1.7,4.7,3.6c0.8,2.9-2.8,2.7-4.4,2.3c-0.5,9.6,10.2,15.6,10.2,25.3c0,2.4-0.7,4-1.3,6.2c-0.5,2.2,0.5,2.8,2.8,3.1
  c3.6,0.6,8.8,1.3,10.4,4.7c1.2,2.4,1.7,3.2,4.5,4.3c2.7,1,3,1.4,2.6,4.3c4.3,1.2,6.8,3.1,8.5,7.3c0.7,1.8,1,3.7,1.3,5.6
  c0.2,1.7,0.8,5.2,0.9,6.8l27.4,2.8l0.2,0.1c0.4-0.2,0.9-0.4,1.4-0.6C134.9,253.4,135.4,253.2,135.5,252.9z"
        />
        <g>
          <text
            transform="matrix(1 0 0 1 115.7156 51.379)"
            className="st6 st7 st8"
          >
            WA
          </text>
        </g>
        <text
          transform="matrix(1 0 0 1 104.8968 91.1754)"
          className="st6 st7 st8"
        >
          OR
        </text>
        <text
          transform="matrix(1 0 0 1 86.3231 190.9151)"
          className="st6 st7 st8"
        >
          CA
        </text>
        <text transform="matrix(1 0 0 1 68.1172 124.58)" className="st9">
          <tspan x="0" y="0" className="st10 st7 st8">
            Pacific{" "}
          </tspan>
          <tspan x="1.8" y="7.2" className="st10 st7 st8">
            States
          </tspan>
        </text>
      </g>
      <g className="west-north-central-hover">
        <path
          className="west-north-central"
          onClick={() => handleClickRegion("West North Central States")}
          d="M316.3,94c1.3,0,19.7,0.7,23,0.8c0-0.8-0.2-1.9-0.4-2.8c-0.1-0.5-0.2-0.9-0.3-1.3c-0.6-3.6-1-7.3-1.4-10.8
  c-0.3-2.6-0.6-5.3-1-7.9c-0.2-1.6-0.7-3-1.2-4.5c-0.4-1.3-0.9-2.7-1.1-4.2c-0.3-1.7-0.7-5.4-0.6-8.6l-31.8-0.8l-28.3-2.5l-3.8,39
  C285.5,91.7,315.2,94,316.3,94z"
        />
        <path
          className="west-north-central"
          onClick={() => handleClickRegion("West North Central States")}
          d="M334.9,63.1c0.2,1.4,0.6,2.6,1.1,4c0.5,1.5,1,3,1.2,4.7c0.4,2.6,0.7,5.3,1,7.9c0.4,3.6,0.8,7.2,1.4,10.8
  c0.1,0.4,0.2,0.8,0.3,1.2c0.3,1.2,0.6,2.5,0.4,3.6c-0.1,0.7-0.5,1.2-1,1.7c-0.6,0.7-1,1.3-0.9,2.2c0.1,0.6,0.6,1.2,1.2,1.8
  c0.6,0.6,1.1,1.3,1.4,2.1c0.4,1.3,0.2,3.3,0.1,4.8c0,0.4-0.1,0.8-0.1,1.2c-0.2,3.8-0.4,7.9-0.4,12.1c0,0.6,0,1.3,0,1.9
  c0.1,1.6,0.1,3.2-0.2,4.8l50.7-1.1c-0.5-1.3-0.8-2-1.9-3.1c-0.6-0.6-1.3-1.1-2-1.7c-1-0.7-2-1.5-2.7-2.4c-0.3-0.4-0.5-0.9-0.7-1.3
  c-0.2-0.5-0.4-0.9-0.7-1.2c-0.5-0.6-1.3-1.1-2.1-1.7c-0.4-0.3-0.8-0.5-1.1-0.8l-0.5-0.4c-1.5-1.1-3.7-2.7-4.1-4.4
  c-0.4-1.3,0.1-2.9,0.4-4.4c0.1-0.6,0.3-1.2,0.4-1.6c0.1-1.1,0-1.8-0.3-2.8c-0.1-0.6-0.3-1.1-0.3-1.8c-0.2-1.7-0.2-3.7,1-5.3
  c0.5-0.6,1-1,1.5-1.4c0.7-0.5,1.3-0.9,1.5-1.6c0.3-0.8,0.2-1.8,0.1-2.8c-0.1-0.9-0.1-1.8,0-2.6c0.1-0.6,0.3-1,0.5-1.3h0
  c0.8-1.9,2.9-2.8,4.5-4c2.1-1.6,3.1-3.4,4.7-5.5c1.6-2.1,4-4,6.5-4.8c2-0.7,6.1-1.7,6.3-4.3c-3.3-0.2-6.9-0.6-10.2-0.5
  c-2.5,0.1-5.3,1.2-7.6-0.3c-1.1-0.7-2-2.5-3.4-2.8c-1-0.2-2.6,0.9-3.9,0.7c-1.8-0.3-5.1-2.4-6-3.8c-1.1,0.5-2.5,1-3.7,1.3
  c-1.9,0.5-1.4,0.3-3-0.4c-3-1.3-7.7-1.1-9.1-4.7l-20.9-0.5C334.2,57.5,334.5,60.9,334.9,63.1z"
        />
        <path
          className="west-north-central"
          onClick={() => handleClickRegion("West North Central States")}
          d="M339.3,132.5c0.1,0.6,0.3,1,0.4,1.4c0.3,1,0.6,1.7,0.2,3.3c-0.5,1.9-0.2,2.7,0.3,4.6l0.1,0.4
  c0.4,1.4,0.9,2.9,1.4,4.3c0.8,2.3,1.6,4.6,2,7c0.2,1.1,0.6,2.1,1,3.2c0.5,1.3,1,2.7,1.2,4.2c0.1,0.6,0,1.4,0,2.1
  c-0.1,1.1-0.2,2.3,0.2,3.1c0.2,0.4,0.4,0.8,0.7,1.3l41.7-1.2l3.1,2c0.1-1.9,0.3-3.1,1.8-4.9l0.4-0.4c1-1.2,1.8-2.2,1.9-3.8
  c0-0.5-0.1-1.1-0.2-1.7c-0.2-1.2-0.4-2.4,0-3.3c0.6-1.4,2-1.5,3.1-1.6c0.5,0,1.1-0.1,1.5-0.2c1.1-0.4,1.6-1.3,1.8-2
  c0.6-1.7,0.3-4-0.7-5.4c-1-1.5-2.3-3.1-3.5-4.6l-0.5-0.6c-0.9-1.2-1.9-1.7-3.6-2l-0.3-0.1l-0.1-0.3c-0.5-1.6-0.7-3.2-0.9-4.8
  c-0.1-1.5-0.3-3-0.8-4.4l-51.3,1.1c-0.1,0.4-0.3,0.8-0.4,1.1C339.4,130.8,339.1,131.5,339.3,132.5z"
        />
        <path
          className="west-north-central"
          onClick={() => handleClickRegion("West North Central States")}
          d="M356.4,178.8c0-0.9-1.1-1.6-3.3-2.1l-69.9-2v38l6.8,0.6l67.6,3.9c0.3-3.3,1.8-22.9,2-25.4c0-0.1,0-0.3,0-0.5
  c0.1-0.6,0.2-1.7,0-2.2c-0.1-0.3-0.3-0.4-0.6-0.6c-0.2-0.1-0.5-0.3-0.8-0.7c-0.9-1.1-2.1-2.9-2.7-4.4c-0.7-1.6-0.2-2.4,0.3-3.2
  C356.1,179.9,356.4,179.5,356.4,178.8z"
        />
        <path
          className="west-north-central"
          onClick={() => handleClickRegion("West North Central States")}
          d="M414.2,223.9c0.1-0.8,0.3-1.7,0.6-2.7l0.1-0.3l0.3-0.1c0.2,0,0.4-0.1,0.7-0.1c1.1-1.4,2.2-3.6,2.4-5.3
  l-2.9-3.5l0-0.2c0.1-1.6-0.7-4.1-1.4-5.6c-0.8-1.9-2.6-2.7-4.5-3.5c-0.6-0.3-1.3-0.6-1.9-0.9c-0.3-0.2-0.6-0.3-0.9-0.5
  c-1.8-0.9-3.6-1.9-3.5-4.1c0.1-1.1,0.6-2,1-2.8c0.5-0.9,1-1.8,0.9-2.8c-0.1-1-0.3-1.3-0.4-1.4c-0.2-0.1-0.6-0.1-1.1,0.1
  c-0.4,0.1-0.9,0.2-1.5,0.2c0,0,0,0,0,0c-2.3,0-2.5-1.4-2.8-2.9l-0.1-0.4c-0.4-2.1-1.7-3.3-3.1-4.7c-1.1-1-2.2-2.1-2.9-3.5
  c-1.7-3.4-2-6.4-1.8-9.7l-3.3-2.1l-40.7,1.2c0.4,0.4,0.7,0.9,1.1,1.3c0.5,0.6,1,1.2,1.4,1.7c0.5,0.7,1,1.3,1.6,1.9
  c0.7,0.8,1.5,1.6,2.1,2.7c1.2,0.3,3.9,1,3.9,3c0,1-0.4,1.6-0.7,2.1c-0.4,0.6-0.7,1.1-0.2,2.2c0.6,1.4,1.7,3.1,2.6,4.1
  c0.2,0.2,0.4,0.3,0.6,0.4c0.3,0.2,0.8,0.5,1,1.1c0.3,0.7,0.2,1.8,0.1,2.7c0,0.2,0,0.4,0,0.5c-0.2,2.6-2,24.7-2,25.8l0.9,6.2
  c1.8,0.6,4.7,0.4,7.2,0.2c1.1-0.1,2.2-0.2,3.2-0.2c0,0,0.1,0,0.1,0c2.1,0,4.3-0.1,6.4-0.3c2.1-0.1,4.3-0.3,6.5-0.3
  c4.6,0,8.9-0.6,13.5-1.1c0.6-0.1,1.1-0.1,1.6-0.2c3.8-0.5,8.5-1.2,12.1-0.1l0.4,0.1l0,0.4c0,0.2,0,0.4,0,0.5
  c0.1,1.1,0.1,2.3-0.5,3.2c-0.4,0.5-0.8,0.7-1.2,0.9c-0.5,0.2-0.7,0.3-0.6,0.9l0.2,0c1.1,0.2,2.2,0.4,3.3,0.4
  C413.8,227,413.9,225.7,414.2,223.9z"
        />
        <path
          className="west-north-central"
          onClick={() => handleClickRegion("West North Central States")}
          d="M349.1,171.8c-0.4-0.5-0.8-1.1-1.3-1.7c-1.1-1.3-2.2-2.6-2.7-3.8c-0.4-1-0.4-2.3-0.3-3.6c0-0.7,0.1-1.3,0-1.9
  c-0.1-1.4-0.6-2.6-1.1-3.9c-0.4-1.1-0.8-2.2-1-3.4c-0.4-2.2-1.2-4.6-1.9-6.8c-0.5-1.4-0.9-2.8-1.3-4.1l-8.3-6.3l-7.1,2.2l-2.8-3.4
  h-6.6l-49.1-3l-2.2,24.5l19.8,2.2v15.1l69,2c-0.5-0.7-1-1.3-1.6-1.9C350.1,173.2,349.6,172.6,349.1,171.8z"
        />
        <path
          className="west-north-central"
          onClick={() => handleClickRegion("West North Central States")}
          d="M314.7,134h7l2.7,3.3l7-2.1l7.6,5.9c-0.4-1.4-0.5-2.4-0.1-4.1c0.3-1.3,0.1-1.8-0.2-2.7
  c-0.1-0.4-0.3-0.9-0.4-1.4c-0.3-1.3,0.1-2.2,0.5-3.1c0.2-0.4,0.4-0.8,0.5-1.3c0.4-1.5,0.3-3.4,0.3-5.1c0-0.7,0-1.3,0-1.9
  c0-4.2,0.2-8.3,0.4-12.1c0-0.4,0-0.8,0.1-1.2c0.1-1.5,0.3-3.4-0.1-4.5c-0.2-0.6-0.6-1.1-1.1-1.7c-0.6-0.7-1.2-1.4-1.4-2.3
  c-0.3-1.3,0.5-2.3,1-3c0.2-0.2,0.4-0.5,0.5-0.7c-3.8-0.1-21.5-0.8-22.7-0.8c-1.3,0-41.7-3.2-46.9-3.6l-1.2,12.1l-2.4,27.5
  L314.7,134z"
        />
        <text transform="matrix(1 0 0 1 300.3867 121.8711)" className="st9">
          <tspan x="0" y="0" className="st10 st7 st8">
            West north central
          </tspan>
          <tspan x="25.2" y="7.2" className="st10 st7 st8">
            states
          </tspan>
        </text>
        <text
          transform="matrix(1 0 0 1 306.7034 155.1485)"
          className="st6 st7 st8"
        >
          NE
        </text>
        <text
          transform="matrix(1 0 0 1 363.8719 149.1998)"
          className="st6 st7 st8"
        >
          IA
        </text>
        <text
          transform="matrix(1 0 0 1 315.3665 194.6534)"
          className="st6 st7 st8"
        >
          KS
        </text>
        <text
          transform="matrix(1 0 0 1 300.2435 74.8517)"
          className="st6 st7 st8"
        >
          ND
        </text>
        <text
          transform="matrix(1 0 0 1 299.7791 114.7628)"
          className="st6 st7 st8"
        >
          SD
        </text>
        <text
          transform="matrix(1 0 0 1 354.3445 80.9181)"
          className="st6 st7 st8"
        >
          MN
        </text>
        <text
          transform="matrix(1 0 0 1 377.9539 192.3082)"
          className="st6 st7 st8"
        >
          MO
        </text>
      </g>
      <g className="west-south-central-hover">
        <path
          className="west-south-central"
          onClick={() => handleClickRegion("West South Central States")}
          d="M371,303.1v-8.7l-5-7.8v-22.7l-5.1-2.5c-1.7,1.6-6.3,0.2-6.5,0.1c-0.4-0.1-0.8-0.3-1.2-0.5
  c-0.8-0.3-1.5-0.6-2.4-0.6c-0.8,0-1.4,0.2-2.1,0.4c-0.4,0.1-0.8,0.3-1.3,0.4c-1.1,0.2-1.9,0.1-2.6-0.1c-0.8-0.1-1.6-0.3-2.5,0.1
  c-0.3,0.1-0.5,0.3-0.7,0.4c-0.3,0.3-0.7,0.6-1.4,0.6c-0.2,0-0.4,0-0.6-0.1c-0.6-0.1-1-0.5-1.3-0.9c-0.2-0.3-0.5-0.5-0.7-0.6
  c-0.8-0.3-2-0.1-3.1,0.1c-0.8,0.1-1.7,0.3-2.5,0.3c-2.8-0.1-4.8-0.9-7-1.8c-0.6-0.2-1.2-0.5-1.9-0.7c-0.8-0.3-1.7-0.3-2.7-0.4
  c-1.3,0-2.6-0.1-3.6-0.8c-0.9-0.6-1.2-1.2-1.4-1.7c-0.3-0.6-0.4-0.8-1.7-0.9c-1,0-1.9,0.1-2.8,0.2c-1.1,0.1-2.3,0.3-3.5,0.2
  c-1.8-0.2-3.5-0.7-4.9-1.4c-0.3-0.2-0.6-0.4-0.8-0.5c-0.4-0.3-0.8-0.6-1.3-0.6l-0.5,0l0-0.5c-0.1-1.7,0.1-3.3,0.3-4.9
  c0.1-1.3,0.3-2.6,0.3-3.9v-18.9l-30.7-3.1l-4.7,61.8l-40.8-3.2l1.6,3.1h-0.4l8,10.1l8.9,5.5v15.2l18.4,8.9l7.3-9.5
  c5-1.1,17.3,3.9,17.3,3.9l6.7,11.2l8.4,14.5l3.4,6.1l2.8,9.5l8.9,3.7l15.6,4.7c-0.9-4.1-1.3-9.4-2.5-13.4c-0.7-2.2-1-3.7,0.4-5.8
  c2.1-3.2,5.5-6.2,8.3-8.8c2.8-2.6,6.2-4.2,8.8-7c1.1-1.1,2.1-2.6,3.6-3.4c1.5-0.8,3.4-0.7,4.9-1.6c2.9-1.6,4.4-4.9,7-7
  c1.9-1.5,4.1-2.5,6.5-3.2v-0.1C368.3,316.3,368.8,307.7,371,303.1z"
        />
        <path
          className="west-south-central"
          onClick={() => handleClickRegion("West South Central States")}
          d="M400.4,283.5c0.5-0.1,1.3-0.3,1.9-0.5c0.8-1.3,1-1.8,0.1-2.8c-0.2-0.2-0.3-0.2-0.6-0.3
  c-0.4-0.1-0.9-0.2-1.3-0.8c-0.4-0.6-0.5-1.5-0.5-2.4c0-0.3,0-0.5-0.1-0.8c-0.4-2.6-0.4-5.2-0.4-8.3c0-1.1-0.1-2.3-0.3-3.5
  c-0.2-1.4-0.4-2.8-0.3-4.1c0.1-2.1,1.5-3.2,2.8-4.3c0.2-0.2,0.5-0.4,0.7-0.6c1.3-1.1,1.9-2.2,2.2-4.2c0.3-2,0.8-4.4,2.2-6.8
  c0.4-0.7,0.9-1.2,1.2-1.6c0.7-0.9,1.1-1.3,0.9-3c0-0.2-0.1-0.4-0.1-0.7c-0.1-0.7-0.3-1.7,0.2-2.5c0.3-0.4,0.7-0.6,1.1-0.8
  c0.3-0.1,0.5-0.2,0.7-0.4c0.6-0.9,0.7-2.6,0.7-4.1c0-0.6,0-1.2,0.1-1.8c-1.1,0-2.2-0.2-3.2-0.4l-0.9-0.1l-0.1-0.3
  c-0.4-1.7,0.5-2.1,1.1-2.4c0.3-0.1,0.6-0.3,0.8-0.6c0.5-0.6,0.4-1.6,0.4-2.6c0-0.1,0-0.1,0-0.2c-3.4-0.9-7.8-0.2-11.3,0.3
  c-0.5,0.1-1.1,0.1-1.5,0.2c-4.7,0.6-9,1.2-13.7,1.2c-2.2,0-4.4,0.1-6.5,0.3c-2.1,0.1-4.4,0.3-6.6,0.3c-0.9,0-2,0.1-3.1,0.1
  c-2.4,0.2-5.2,0.4-7.1-0.1l1.8,12.2v23.2l5.6,2.8v23.1l2,3.1c7.2-1.7,14.5-2.9,21.4-4C394.3,284.8,397.5,284.2,400.4,283.5z"
        />
        <path
          className="west-south-central"
          onClick={() => handleClickRegion("West South Central States")}
          d="M421.3,317.7c-0.5-1.3-0.2-3.4-0.2-4.7c0-1.5-0.1-2.4,0.1-3l-0.3-0.3l0-0.2c-0.2-1.7-0.9-4.4-1.6-5.9
  c-0.2-0.4-0.5-0.7-0.8-1.1c-0.5-0.5-1-1-1.1-1.8c-0.1-0.7,0.1-1.3,0.3-1.9c0.1-0.2,0.2-0.5,0.2-0.7c-3.5-0.5-6.9-0.3-10.5-0.1
  l-1.8,0.1c-0.6,0-1.3,0.1-2,0.2c-2,0.2-4.3,0.4-5.8,0c-0.8-0.2-1.3-0.6-1.6-1c-0.4-0.8-0.1-1.6,0.4-2.9c0.4-1.1,1-2.1,1.6-3.1
  c0.4-0.6,0.7-1.3,1.1-1.9c0.4-0.8,0.7-1.7,1-2.5c0.4-0.9,0.7-1.9,1.2-2.8c-0.3,0.1-0.6,0.2-0.9,0.3c-3,0.7-6.1,1.4-10.1,2
  c-6.8,1-14,2.2-21,3.9l2.5,3.9v9.2l0,0.1c-2,4-2.6,11.9-2.7,13.1c4-1,8.4-1.2,12.4-1.7c1.1-0.1,2.2-0.4,3.2-0.6
  c0.7,1.1,2.6,2.8,3.8,3.2c1.5-0.1,2.1-2.1,3.4-2.5c1-0.3,2.5,0.5,3.4,0.9c2.4,1,4.7,2.6,6.8,4.2c1.1,0.9,1.8,1.9,3.5,1.7
  c1.6-0.1,2.5-1.7,4.3-1.7c1.2,0,3,1.5,4,0.6c1-0.8,0.2-3.3,0.2-4.5c2.7-0.3,3.2,1.1,4.6,3c1.6,2,3.5,2.5,6,1.9
  C424.4,319.6,422,319.3,421.3,317.7z"
        />
        <path
          className="west-south-central"
          onClick={() => handleClickRegion("West South Central States")}
          d="M289.9,214.4l-6.7-0.6v0.1h-1v-0.2l-11.7-1l-0.6,7.6l31.6,3.1v19.8c0,1.4-0.1,2.7-0.3,4
  c-0.2,1.4-0.3,2.9-0.3,4.3c0.6,0.1,1,0.4,1.4,0.8c0.2,0.2,0.4,0.3,0.7,0.5c1.2,0.7,2.8,1.1,4.5,1.3c1.1,0.1,2.1,0,3.3-0.2
  c1-0.1,2-0.3,3-0.2c1.7,0.1,2.1,0.6,2.5,1.5c0.2,0.4,0.4,0.9,1.1,1.3c0.7,0.5,1.9,0.5,3.1,0.6c1,0,2.1,0.1,3,0.4
  c0.7,0.3,1.3,0.5,1.9,0.8c2.2,0.9,4.1,1.6,6.7,1.8c0.6,0,1.4-0.1,2.2-0.3c1.2-0.2,2.5-0.5,3.6-0.1c0.5,0.2,0.8,0.5,1.1,0.9
  c0.3,0.3,0.5,0.6,0.8,0.6c0.6,0.1,0.8,0,1.2-0.3c0.2-0.2,0.5-0.4,0.9-0.6c1.2-0.5,2.1-0.3,3-0.2c0.7,0.1,1.4,0.2,2.3,0.1
  c0.4-0.1,0.8-0.2,1.2-0.3c0.7-0.2,1.4-0.5,2.4-0.4c1.1,0,2,0.4,2.8,0.7c0.4,0.1,0.7,0.3,1.1,0.4c1.9,0.6,4.9,1,5.7,0l0.1,0v-23.2
  l-2.7-19.1L289.9,214.4z"
        />
        <text transform="matrix(1 0 0 1 278.8961 270.7946)" className="st9">
          <tspan x="0" y="0" className="st10 st7 st8">
            West south central
          </tspan>
          <tspan x="24.8" y="7.2" className="st10 st7 st8">
            states
          </tspan>
        </text>
        <text
          transform="matrix(1 0 0 1 380.6942 251.2979)"
          className="st6 st7 st8"
        >
          AR
        </text>
        <text
          transform="matrix(1 0 0 1 326.5067 238.4278)"
          className="st6 st7 st8"
        >
          OK
        </text>
        <text
          transform="matrix(1 0 0 1 303.2503 294.7047)"
          className="st6 st7 st8"
        >
          TX
        </text>
        <text
          transform="matrix(1 0 0 1 384.5779 302.7428)"
          className="st6 st7 st8"
        >
          LA
        </text>
      </g>
      <g className="east-south-atlantic-hover">
        <path
          className="east-south-atlantic"
          onClick={() => handleClickRegion("East South Central States")}
          d="M440.5,302c-0.7-0.7-2.2-0.7-3.7-0.6c-1.5,0-3,0.1-3.8-0.7c-0.5-0.5-0.6-2.1-0.6-5.1c0-0.7,0-1.4,0-1.6
  c-0.3-2.6-0.7-5.6-1.4-9c-1.2-6.4-1.8-12.1-0.6-18.7c0.5-3.1,0.6-6.3,0.8-9.3c0.1-2.7,0.2-5.5,0.6-8.3c0.1-0.5,0.1-1,0.2-1.5
  c0.4-2.3,0.8-5,0.2-7c-0.3,0-0.5,0.1-0.8,0.1c-7.3,1.1-14.8,2.3-22.1,2.4c-0.1,0.2-0.3,0.4-0.5,0.6c-0.3,0.4-0.7,0.8-1.1,1.5
  c-1.4,2.2-1.8,4.5-2.1,6.4c-0.3,1.9-0.8,3.3-2.5,4.8c-0.2,0.2-0.5,0.4-0.7,0.6c-1.3,1-2.4,1.9-2.4,3.5c-0.1,1.2,0.1,2.5,0.3,3.9
  c0.1,1.2,0.3,2.4,0.3,3.6c0,3,0.1,5.6,0.4,8.2c0,0.2,0,0.5,0.1,0.8c0,0.7,0.1,1.5,0.4,1.9c0.2,0.3,0.3,0.3,0.6,0.4s0.7,0.1,1.1,0.5
  c1.6,1.6,0.8,2.8,0.1,4c-0.1,0.2-0.3,0.4-0.4,0.6c-0.6,1-1,2.1-1.4,3.2c-0.3,0.9-0.7,1.8-1.1,2.6c-0.3,0.7-0.7,1.4-1.1,2
  c-0.6,1-1.1,1.8-1.5,2.9c-0.4,1-0.6,1.8-0.5,2.1c0.1,0.2,0.4,0.4,1,0.5c1.4,0.4,3.5,0.2,5.5,0c0.7-0.1,1.5-0.1,2-0.2l1.8-0.1
  c3.6-0.2,7.4-0.4,11.1,0.1l0.4,0.1l0,0.4c0,0.5-0.2,1-0.3,1.5c-0.2,0.5-0.3,0.9-0.2,1.4c0.1,0.5,0.5,0.9,0.9,1.3
  c0.4,0.4,0.8,0.8,1,1.4c0.6,1.5,1.4,4.1,1.6,5.9c0.3-0.2,0.8-0.5,1.4-0.7c2.9-1.2,5.6-3,8.7-3.6c2.8-0.6,6.1,0.4,8.9-0.6v-0.4
  C441,302.9,440.8,302.4,440.5,302z"
        />
        <path
          className="east-south-atlantic"
          onClick={() => handleClickRegion("East South Central States")}
          d="M443.7,299.8c-0.3-0.3-0.5-0.5-0.7-0.7c-0.5-0.4-1.1-0.9-1.3-2.1c-0.2-1,0-1.8,0.5-2.4
  c0.9-1.1,2.8-1.1,4.5-1.1c0.7,0,1.4,0,1.9-0.1c1.1-0.1,2.1-0.4,3.2-0.7c0.8-0.2,1.7-0.5,2.6-0.6c1.5-0.3,2.8-0.1,4,0
  c0.5,0.1,1.1,0.1,1.7,0.1c1.8,0.1,3.6-0.3,5.4-0.6l0.9-0.2c0.4-0.1,0.8-0.1,1.4-0.2c1.7-0.3,4.8-0.7,5.4-1.4
  c-0.1-0.5-0.3-1.1-0.5-1.7c-0.2-0.6-0.5-1.2-0.8-1.9c-0.6-1.3-1.2-2.7-1.4-4.1c-0.1-1.3,0-2.4,0.2-3.5c0.3-1.8,0.5-3.4-0.5-5.3
  c-1.9-3.3-2.6-6.4-3.4-9.9c-0.4-1.8-1.3-3.5-2.2-5.3c-0.7-1.3-1.4-2.7-1.8-4c-2.1-5.8-3.3-11.2-3.9-16.5c-6.1,0-12.4,0.2-18.5,1
  c-2.4,0.3-4.8,0.7-7.3,1c0.6,2.2,0.2,5-0.2,7.3c-0.1,0.5-0.2,1-0.2,1.5c-0.4,2.7-0.5,5.5-0.6,8.2c-0.1,3.1-0.3,6.3-0.8,9.4
  c-1.1,6.5-0.5,12,0.6,18.3c0.6,3.5,1.1,6.5,1.4,9.1c0,0.4,0,1,0,1.8c0,1.2,0,4,0.3,4.4c0.5,0.5,1.8,0.5,3.1,0.4
  c1.7,0,3.5-0.1,4.5,1c0.5,0.6,0.7,1.4,0.6,2.4c1.3-0.6,1.6-0.9,2.7-0.9l0-0.2C444.6,301.2,444.6,300.8,443.7,299.8z"
        />
        <path
          className="east-south-atlantic"
          onClick={() => handleClickRegion("East South Central States")}
          d="M489,195.1l-0.1-0.2c-1.1-1.3-2.1-2.5-2.3-4.1c-0.1-0.9,0.1-1.8,0.2-2.6c0.1-0.4,0.2-0.9,0.2-1.3
  c-0.3-0.1-0.6-0.2-0.9-0.4c-0.4-0.2-0.8-0.4-1.1-0.6c-1.4-0.8-1.7-1-3.6-0.4c-2,0.6-3.2,0.4-4.9,0.1c-0.3-0.1-0.7-0.1-1-0.1
  c-0.8-0.1-1.6,0.2-2.5,0.4c-1,0.3-2,0.6-2.8,0.3c-1-0.3-1.7-1.2-2.4-2c-0.6-0.7-1.2-1.4-1.9-1.8c-0.6-0.3-1.4-0.4-2.1-0.6
  c-0.4-0.1-0.9-0.1-1.3-0.3c0,1.5-0.2,3.3-0.6,4.7c-0.5,1.8-1.6,1.7-2.4,1.6c-0.7-0.1-1.2-0.1-1.9,0.5c-0.4,0.4-0.5,1-0.7,1.7
  c-0.2,0.9-0.4,1.9-1.3,2.6c-0.4,0.4-0.8,0.6-1.1,0.9c-0.7,0.5-1.2,0.9-1.7,1.9c-0.2,0.4-0.4,0.9-0.5,1.3c-0.4,1.1-0.8,2.1-1.8,2.5
  c-0.7,0.3-1.5,0.1-2.6-0.4c-0.5-0.3-0.9-0.7-1.1-1c-0.4-0.5-0.5-0.6-1.2-0.3c-0.5,0.2-0.7,0.5-1,0.9c-0.3,0.5-0.7,1-1.6,1.3
  c-0.7,0.2-1.5,0.1-2.2,0.1c-0.6-0.1-1.1-0.1-1.6,0c-0.9,0.1-1.3,0.5-1.9,0.9c-0.3,0.2-0.6,0.5-1.1,0.8c-1,0.6-1.6,0.5-2.2,0.5
  c-0.3,0-0.6,0-1,0c-0.7,0.1-1.6,0.8-2.4,1.4c-0.4,0.3-0.7,0.6-1.1,0.8c0,0,0,0,0,0c0.1,0.7,0.3,1.4,0.2,2.3
  c-0.2,2.1-0.7,2.5-2.3,3.4L427,210c-0.5,0.3-1.4,0.8-1.8,1.2c0,0.1,0,0.3,0,0.4c0.1,0.4,0.2,1.1-0.6,1.5c-0.6,0.3-1.4-0.1-2.3-0.4
  c-0.8-0.4-1.7-0.8-2.3-0.5c-0.9,0.4-1,0.9-0.9,2.1c0,0.4,0,0.7,0,1.1c-0.1,1.6-0.9,3.7-2,5.2c0.6-0.1,1.1-0.2,1.7-0.3
  c1.9-0.4,3.9-0.7,5.8-0.9c0.4,0,0.9,0,1.4,0c0.8,0,1.9,0.1,2.3-0.1c0.5-0.3,0.6-0.6,0.7-1.3c0.1-0.3,0.1-0.7,0.3-1.1l0.1-0.3
  l0.3-0.1c8.9-1.6,16.2-2.7,23.1-3.4c1.9-0.2,3.9-0.4,5.9-0.6c8-0.8,16.3-1.7,24.4-1.8c0.3,0,0.5,0,0.8,0c0.8-1.3,2.3-2.8,3.8-4.3
  c0.9-0.9,1.7-1.6,2.4-2.4c0.4-0.4,0.8-0.9,1.2-1.5c0.7-1,1.5-1.9,2.2-2.6C492.1,198.6,490.6,197,489,195.1z"
        />
        <path
          className="east-south-atlantic"
          onClick={() => handleClickRegion("East South Central States")}
          d="M458.8,213.5c-2,0.2-3.9,0.4-5.9,0.6c-6.8,0.7-14,1.7-22.7,3.3c-0.1,0.2-0.1,0.5-0.1,0.7
  c-0.1,0.7-0.3,1.5-1.2,2c-0.6,0.3-1.8,0.3-2.8,0.3c-0.5,0-0.9,0-1.2,0c-1.9,0.2-3.9,0.6-5.7,0.9c-0.9,0.2-1.8,0.4-2.8,0.5
  c-0.2,0.2-0.4,0.5-0.6,0.6l-0.2-0.2c-0.2,0.7-0.3,1.3-0.4,1.9c-0.3,1.7-0.5,3.4-2.6,4.9c-0.1,0.6-0.1,1.3-0.1,2.2
  c0,1.7,0,3.5-0.9,4.7c-0.3,0.4-0.7,0.6-1.1,0.8c-0.3,0.1-0.5,0.2-0.7,0.4c-0.3,0.4-0.2,1.1,0,1.7c0.1,0.3,0.1,0.6,0.1,0.8
  c0.1,0.9,0,1.6-0.1,2.1c7.1-0.1,14.4-1.2,21.5-2.3c3-0.5,6-0.9,9-1.3c8.5-1.1,17.3-1.1,25.7-1c1.5,0,2.9,0,4.4,0
  c0.9,0,1.8,0,2.7-0.1c0.1-3,2.7-6,5.3-7.8l0.3-0.2c2.9-2,5.4-3.6,7.9-6.1c1.3-1.3,2.9-2,4.5-2.6c1.4-0.6,2.6-1.1,3.8-2.1
  c0.7-0.6,1.4-1.4,2-2.3c0.4-0.5,0.8-1,1.1-1.5c0.9-1,1.5-2.3,1.7-3.9c-5.5,0.7-11,1.3-16.6,1.4
  C475.1,211.8,466.8,212.6,458.8,213.5z"
        />

        <text
          transform="matrix(0.9997 -2.636065e-02 2.636065e-02 0.9997 414.071 256.9903)"
          className="st9"
        >
          <tspan x="0" y="0" className="st10 st7 st8">
            east South
          </tspan>
          <tspan x="5.2" y="7.2" className="st10 st7 st8">
            Atlantic
          </tspan>
          <tspan x="9" y="14.4" className="st10 st7 st8">
            states
          </tspan>
        </text>
        <text
          transform="matrix(1 0 0 1 408.2469 271.131)"
          className="st6 st7 st8"
        >
          TN
        </text>
        <text
          transform="matrix(1 0 0 1 446.8983 269.7511)"
          className="st6 st7 st8"
        >
          AL
        </text>
        <text
          transform="matrix(1 0 0 1 444.0858 231.4278)"
          className="st6 st7 st8"
        >
          TN
        </text>
        <text
          transform="matrix(1 0 0 1 458.0545 204.0865)"
          className="st6 st7 st8"
        >
          KY
        </text>
      </g>
      <text
        transform="matrix(1 0 0 1 527.4041 149.9063)"
        className="st6 st7 st8"
      >
        PA
      </text>

      <g className="south-atlantic-states-hover">
        <path
          className="south-atlantic-states"
          onClick={() => handleClickRegion("South atlantic States")}
          d="M517.3,271.8L517.3,271.8c-3.5-1.5-7.3-7.5-8-10.7c-0.5-2-2.2-3-3.9-4c-1.5-0.9-3-1.8-4-3.3
  c-0.3-0.4-0.6-0.9-0.8-1.2c-0.7-1.1-1.2-2-2.6-2.9c-0.3-0.2-0.6-0.4-0.9-0.6c-1.2-0.8-2.1-1.4-3-2.7l-0.5-0.7
  c-0.6-0.9-1.1-1.8-1.8-2.6c-0.7-0.9-1.1-1-1.9-1.2c-0.4-0.1-0.9-0.2-1.5-0.4l-0.3-0.1l0-0.3c-0.1-0.9-0.6-1.5-1.1-2.1
  c-0.6-0.8-1.4-1.7-1.1-3c-5,1.1-10.2,1.8-15.5,1.8c-1.5,0-2.9,0-4.4,0c-2,0-4.1,0-6.1,0c0.5,5.1,1.8,10.4,3.8,16.2
  c0.5,1.3,1.1,2.6,1.8,3.9c0.9,1.8,1.8,3.6,2.3,5.5c0.8,3.4,1.5,6.4,3.3,9.6c1.2,2.2,0.9,4.1,0.7,5.9c-0.1,1-0.3,2.1-0.2,3.2
  c0.1,1.2,0.7,2.5,1.3,3.8c0.3,0.6,0.6,1.3,0.8,1.9c0.3,0.8,0.5,1.6,0.7,2.4c0.3,1,0.5,1.9,0.9,2.8l0.2,0.5c0.4,0.9,0.4,0.9,1.3,1
  c0.9,0.1,1.9-0.2,2.9-0.4c0.6-0.1,1.2-0.3,1.8-0.4c3-0.4,6-0.5,9-0.7l1.7-0.1c1.7-0.1,3.5-0.2,5.2-0.3c1.6-0.1,3.3-0.2,4.9-0.3
  c1.6-0.1,2.1,0.1,3.4,1.1c0.3,0.2,0.5,0.5,0.8,0.7c0.5,0.4,0.8,0.7,1.2,0.8c0-0.7,0.4-1.1,0.7-1.5c0.2-0.3,0.4-0.6,0.5-1
  c0.1-0.3,0-0.6-0.1-1c-0.2-0.5-0.4-1.2,0.3-1.9c1.1-1.1,5.2,0.5,5.8,0.7l0.1,0c-0.6-4.2,0.6-8.1,1.4-12.1c0.4-2.1,0.4-4.2,1-6.2
  c0,0-0.1,0-0.1-0.1L517.3,271.8z"
        />
        <path
          className="south-atlantic-states"
          onClick={() => handleClickRegion("South atlantic States")}
          d="M509.7,290.4c-0.2,0.2-0.2,0.4,0,0.9c0.1,0.4,0.3,0.9,0.1,1.5c-0.1,0.6-0.4,1-0.7,1.3
  c-0.3,0.4-0.5,0.8-0.5,1.4l0,0.5l-0.5,0.1c-0.1,0-0.3,0-0.4,0c-1,0-1.5-0.6-2-1.1c-0.2-0.2-0.4-0.4-0.6-0.6c-1.1-0.8-1.4-1-2.8-0.9
  c-1.6,0.1-3.3,0.2-4.9,0.3c-1.7,0.1-3.5,0.2-5.2,0.3l-1.7,0.1c-3.1,0.1-6,0.3-9,0.7c-0.5,0.1-1.1,0.2-1.7,0.3
  c-1.1,0.3-2.2,0.5-3.2,0.4c-1.5-0.1-1.7-0.4-2.2-1.6l-0.2-0.5c-0.4-0.9-0.6-1.8-0.8-2.6c-1,0.6-3.1,1-5.5,1.3
  c-0.5,0.1-1,0.1-1.4,0.2l-0.9,0.2c-1.9,0.4-3.6,0.7-5.6,0.6c-0.6,0-1.2-0.1-1.8-0.1c-1.3-0.1-2.4-0.3-3.7,0
  c-0.9,0.2-1.7,0.4-2.5,0.6c-1.1,0.3-2.2,0.6-3.4,0.7c-0.6,0.1-1.3,0.1-2.1,0.1c-1.5,0-3.1,0-3.8,0.7c-0.3,0.3-0.4,0.9-0.2,1.5
  c0.1,0.9,0.5,1.1,1,1.5c0.3,0.2,0.6,0.4,0.9,0.8c1.1,1.2,1.1,2,1.1,3.5v0.2l0,0c0,0,0,0,0.1,0c3.3,0.3,6.5-0.9,9.8-1.1
  c1.2-0.1,6,1.1,6,0.4c1.3,0.1,3.3,0.5,4.4,1.1c1.8,1,0.8,0.7,1.5,2.2c0.9,1.9,2.3,2.5,4,3.6c1.5,0.9,0.7,1,2.4,0.6
  c1.1-0.3,2.2-1.2,3.2-1.6c2.3-1.1,4.7-3.5,7.2-4c5-1.1,7.8,4.4,11,7.2c3.7,3.2,7.6,4.2,8.7,9.3c0.8,4.1-1.8,7.8,1.9,11.1
  c0-0.4,0.4-0.9,0.3-1.4c2.9-0.8,1.5,1.5,1,2.7c-0.8,2.1-0.2,1.9,1.2,3.6c1.4,1.7,2.7,6.8,5.6,6.2c0.1,1.4,0,2.8,0.1,4.2
  c2.1,0.1,3.6,0,4.6,2.2c1,2,0,3.8,2.4,5.1c1.6,0.8,3.7,0.6,4.9,2.1c1,1.2,0.8,3,1.8,4.4c0.9,1.3,3,4.4,4.4,4.5
  c1.1,0.1,3.7-1.5,4.7-2.1c2-1.2,1.8-2.2,1.8-4.4c0-2,0.5-3.5,0.8-5.4c1-5.7-1-11-1.2-16.6c-0.2-5.9-4.8-12-8.3-16.8l-1.7-3
  c-2.3-3.7-3.9-7.5-6-11.3c-2.5-4.4-6-9-7.1-14.1l-0.5-0.1C513,290.7,510.1,290,509.7,290.4z"
        />
        <path
          className="south-atlantic-states"
          onClick={() => handleClickRegion("South atlantic States")}
          d="M533.8,239.5c-0.2-0.2-0.5-0.4-0.7-0.6c-0.4-0.4-0.8-0.8-1.3-1.2c-0.9-0.9-1.8-1.7-2.9-2.5
  c-0.3-0.2-0.6-0.4-1-0.6c-1-0.6-2.2-1.3-2.8-2.4c-4.7,0.9-8.9,1.2-13.1,1l-0.3,0l-0.1-0.3c-0.4-1.3-1-2.1-1.8-2.5
  c-1.5-0.8-3.7,0-6,0.8c-0.6,0.2-1.2,0.4-1.7,0.6c-4.7,1.4-9.8,3-15,4.2c-0.5,1.1,0,1.7,0.7,2.6c0.5,0.6,1.1,1.3,1.3,2.3
  c0.4,0.1,0.7,0.2,1,0.3c0.8,0.2,1.5,0.3,2.4,1.5c0.7,0.9,1.3,1.8,1.9,2.7l0.5,0.7c0.7,1.1,1.5,1.6,2.7,2.4c0.3,0.2,0.6,0.4,0.9,0.6
  c1.5,1.1,2.1,2.1,2.9,3.2c0.2,0.4,0.5,0.8,0.8,1.2c0.9,1.3,2.3,2.2,3.7,3c1.9,1.1,3.8,2.3,4.4,4.7c0.7,3,4.4,8.6,7.5,10l0,0
  c1-2,2.6-3.3,4-5c2-2.4,4-4.9,6.1-7.3c1.9-2.1,4.4-3.9,5.6-6.3c1-1.9,1.5-2.7,3.2-4.2c1.3-1.2,2.6-3,3.4-4.7l-0.1-0.1
  C537.6,243,535.5,241.2,533.8,239.5z"
        />
        <path
          className="south-atlantic-states"
          onClick={() => handleClickRegion("South atlantic States")}
          d="M557.5,215.7c1.5,0.7,2.2,3.7,4.3,2.8c1-0.4,1.9-3.3,2.6-4.3c0.9-1.2,2.1-2.7,1.2-4.3c-1.3-2.3-2.3,0-3.5,1
  c-1.7-3.6-5,0.7-6.4-1.2c-1.2-1.6,2-1.7,2.5-1.9c1.4-0.6,1.8-0.6,1.7-2.5c2.3-0.4,2.5-2.1,2-3.9c-0.9,0.4-2.5,0.5-3.6,0.5
  c-0.4,0-0.7,0-1.1,0c-1.3,0.1-2.6,0.4-3.9,0.7c-0.3,0.1-0.7,0.1-1,0.2c-2.7,0.6-5.5,1.1-8.2,1.5c-2,0.3-4,0.6-6,1
  c-5.7,1.1-11.6,1.7-17.3,2.3c-2.7,0.3-5.5,0.6-8.3,0.9c-2.4,0.3-4.8,0.6-7.1,1c-1.5,0.2-3.1,0.4-4.6,0.6c-0.3,1.9-1,3.4-2,4.7
  c-0.4,0.4-0.7,0.9-1.1,1.4c-0.6,0.9-1.3,1.8-2.1,2.5c-1.2,1-2.6,1.6-4,2.2c-1.5,0.7-3,1.3-4.2,2.4c-2.6,2.5-5.1,4.2-8,6.2l-0.3,0.2
  c-2.3,1.5-4.7,4.3-4.9,6.9c9.8-0.6,19.2-3.5,27.7-6.1c0.6-0.2,1.1-0.4,1.7-0.6c2.4-0.8,4.8-1.7,6.7-0.7c1,0.5,1.7,1.4,2.2,2.8
  c4.2,0.2,8.3-0.1,12.9-1.1l0.4-0.1l0.1,0.4c0.3,1,1.5,1.7,2.5,2.3c0.4,0.2,0.7,0.4,1,0.7c1.1,0.8,2,1.7,3,2.6
  c0.4,0.4,0.8,0.8,1.2,1.1c0.2,0.2,0.5,0.4,0.7,0.6c1.7,1.6,3.7,3.4,5.8,3.6l0.2,0l0.3,0.3c3.2-0.4,4.6,1.1,5-3.2
  c0.2-1.6,0.2-3,1-4.2c0.8-1.2,2.3-2.3,3.2-3.6c0.7-0.9,1.8-3.5,2.6-4c0.8-0.5,3.5-0.2,4.4-0.3c4.2-0.2,5.6-1.4,5.3-5.7
  c-1.3-0.1-6.2,4.9-5.7,0.6c0.2-1.6,1.3-1.4,0.7-3.4C556.8,217.6,555.6,216.7,557.5,215.7z"
        />
        <text
          transform="matrix(0.9997 -2.636065e-02 2.636065e-02 0.9997 483.1423 284.4723)"
          className="st9"
        >
          <tspan x="0" y="0" className="st10 st7 st8">
            South{" "}
          </tspan>
          <tspan x="-3.6" y="7.2" className="st10 st7 st8">
            Atlantic
          </tspan>
          <tspan x="0.2" y="14.4" className="st10 st7 st8">
            states
          </tspan>
        </text>
        <text
          transform="matrix(1 0 0 1 484.1033 269.8228)"
          className="st6 st7 st8"
        >
          GA
        </text>
        <text
          transform="matrix(1 0 0 1 513.8631 249.484)"
          className="st6 st7 st8"
        >
          SC
        </text>
        <text
          transform="matrix(1 0 0 1 515.6844 220.5103)"
          className="st6 st7 st8"
        >
          NC
        </text>
        <text
          transform="matrix(1 0 0 1 516.5887 331.6915)"
          className="st6 st7 st8"
        >
          FL
        </text>
      </g>

      <g className="east-north-central-hover">
        <path
          className="east-north-central"
          onClick={() => handleClickRegion("East North Central States")}
          d="M399.6,85.1c0.9,1.6,1.7,2.2,3.2,2.4c0.6,0.1,1.3,0.1,1.9,0.2c1.3,0.1,2.6,0.2,4,0.7c0.5,0.2,1,0.3,1.5,0.5
  c1.6,0.6,3.2,1.1,4.9,1.4c0.5,0.1,1.2,0.2,2,0.3c1.4,0.1,2.8,0.3,3.6,0.7c1,0.5,1.9,2.1,2.6,3.5l0.1,0.1c0.4,0.8,0.8,1.5,1.2,2.2
  c0.6,1.1,1.1,2.2,1.8,3.2c0.2-0.5,0.5-0.9,0.8-1.3c2-3,3-6.2,6.6-7.2c1.7-0.5,3.6-0.4,5.3-1.1c1.5-0.6,2.5-1.3,4-1.7
  c4.9-1,10.1-0.8,14.9-2.4c-0.7-0.9-1.3-2-2.1-2.9c-1.1-1.3-1.5-1.3-3.2-1.5c-4-0.4-3.9-1.1-4.1-4.8c-2-0.4-2.6,1.1-4.2,1.6
  c-1.3,0.4-3,0.1-4.3,0.2c-2,0.2-3.1,1.2-4.8,2c-1.4,0.7-3,0.6-4.5,1.3c-3.1,1.5-4.9,1.5-7.5-1.3c-1.2-1.3-1.4-2-3.2-2.4
  c-1.4-0.3-2.6,0.1-4-0.5c-0.9-4.4,6.6-4.3,5.7-8c-2.8,0.3-5.8,2.9-7.8,4.9c-1.3,1.2-2.2,2.8-3.3,4c-1.1,1.3-1.3,1-3.2,1.5
  c-1.7,0.4-3.1,1.2-4.6,1.9c-1.7,0.8-1.2,0.5-3,0.3c-0.2,0-0.5,0-0.7-0.1C399.1,83.6,399.1,84.3,399.6,85.1z"
        />
        <path
          className="east-north-central"
          onClick={() => handleClickRegion("East North Central States")}
          d="M466.9,143.6l-1.1,0.2c-2.5,0.5-4.8,0.9-7.3,1.2c1.2,3.3,1.3,7.1,1.5,10.9c0.1,2.1,0.1,4.1,0.4,6.1
  c0.2,1.6,0.5,3.3,0.7,4.9c0.7,4.5,1.4,9.1,1.4,13.6c0,0,0,0.1,0,0.1c0.5,0.1,0.9,0.2,1.5,0.3c0.8,0.1,1.6,0.3,2.4,0.6
  c0.9,0.4,1.5,1.2,2.2,2c0.7,0.8,1.3,1.5,2,1.7c0.6,0.2,1.4-0.1,2.3-0.3c1-0.3,2-0.6,2.9-0.5c0.4,0.1,0.7,0.1,1,0.1
  c1.6,0.3,2.6,0.4,4.4-0.1c2.3-0.7,2.9-0.3,4.4,0.5c0.3,0.2,0.6,0.4,1,0.6c0.8,0.4,1.4,0.5,1.8,0.4c0.6-0.2,1.2-1.1,1.8-2.3
  c0.3-0.7,0.4-1.4,0.5-2.1c0.2-1.1,0.4-2.3,1.4-3.2c0.3-0.3,0.7-0.3,1-0.4c0.4-0.1,0.6-0.1,0.8-0.3c0.3-0.3,0.4-0.9,0.5-1.4
  c0.1-0.4,0.2-0.8,0.3-1.2c0.7-1.6,2.2-2.8,3.6-3.9c1.5-1.2,3-2.3,3.4-3.9c0.3-0.9,0.4-1.8,0.5-2.8c0.1-1,0.2-2,0.5-3
  c0.5-1.8,0.6-2.7,0.4-4.1c-0.6-5.8-1.3-10.7-2.2-14.9c-0.1-0.5-0.2-1.5-0.4-2.8c-0.1-1.2-0.4-3.4-0.7-5.4
  c-3.7,2.6-7.5,4.9-11.6,7.1c-2.1,1.1-6,3.8-8.3,3.8c-1,0-2.4-0.6-3.8-1.2C474.1,143.5,468.5,143.3,466.9,143.6z"
        />
        <path
          className="east-north-central"
          onClick={() => handleClickRegion("East North Central States")}
          d="M380.8,85.8c-0.1,0.7-0.1,1.5,0,2.3c0.1,1.1,0.2,2.2-0.2,3.2c-0.4,1-1.1,1.5-1.9,2.1c-0.5,0.4-1,0.7-1.4,1.2
  c-1,1.3-1,2.9-0.8,4.5c0.1,0.6,0.2,1.2,0.3,1.7c0.2,1,0.5,1.9,0.3,3.1c-0.1,0.5-0.2,1.1-0.4,1.7c-0.3,1.4-0.7,2.9-0.4,3.9
  c0.4,1.3,2.4,2.8,3.8,3.8l0.5,0.4c0.4,0.3,0.7,0.5,1.1,0.8c0.8,0.6,1.7,1.1,2.3,1.9c0.4,0.4,0.6,0.9,0.8,1.4
  c0.2,0.4,0.4,0.8,0.6,1.1c0.6,0.9,1.5,1.5,2.5,2.3c0.7,0.5,1.5,1.1,2.1,1.7c1.3,1.3,1.6,2.2,2.2,3.7l0.1,0.4c0.6,1.7,0.8,3.4,0.9,5
  c0.1,1.5,0.3,2.9,0.7,4.3c1.5,0.3,2.8,0.8,3.9,2.3l0.5,0.6c0,0.1,0.1,0.1,0.1,0.2l0.1-0.2c1,0.4,2.7,0.3,4.3,0.1
  c0.8-0.1,1.5-0.1,2.2-0.1c1.4,0,2.8-0.1,4.2-0.1c1.4-0.1,2.8-0.1,4.2-0.1c2.9,0,5.9-0.1,8.7-0.2c2.2-0.1,4.4-0.1,6.6-0.2
  c-0.4-3.6-1.7-7.1-1.6-10.5c0.1-2.8,0.9-5.5,0.9-8.3c0-2.1-0.4-4.6,0.3-6.6c0.7-2.2,1.5-4,1.9-6.4c0.3-2.1,1.7-4.8,1.7-6.8
  c-1.6,0.3-2.8,2.6-3.8,3.8c-1.4,1.8-3.3,4-5.5,4.8c-0.3-1.7,1.1-2.9,1.9-4.2c0.6-1,1-2.1,1.5-3.2c-0.9-1.2-1.5-2.5-2.2-3.9
  c-0.4-0.7-0.7-1.4-1.1-2.2l-0.1-0.1c-0.5-0.9-1.5-2.6-2.2-3.1c-0.6-0.3-2-0.5-3.3-0.6c-0.8-0.1-1.6-0.2-2.1-0.3
  c-1.7-0.4-3.3-0.9-5-1.5c-0.5-0.2-1-0.3-1.5-0.5c-1.3-0.4-2.5-0.5-3.8-0.6c-0.6-0.1-1.3-0.1-1.9-0.2c-2.1-0.3-3.1-1.4-4-2.9
  c-0.6-1-0.6-1.9-0.5-2.8c-2.2-0.1-4.6-0.2-2.5-3c-4.8,2-8.7,4.5-13.9,4.6C381.3,84.7,380.9,85,380.8,85.8z"
        />
        <path
          className="east-north-central"
          onClick={() => handleClickRegion("East North Central States")}
          d="M413.5,140.1c-1.4,0-2.8,0.1-4.2,0.1c-1.4,0.1-2.8,0.1-4.2,0.1c-0.6,0-1.3,0.1-2.1,0.1
  c-0.9,0.1-1.7,0.2-2.5,0.2c-0.4,0-0.7,0-1.1-0.1c0.9,1.1,1.9,2.4,2.6,3.5c1.1,1.7,1.5,4.4,0.9,6.3c-0.4,1.3-1.3,2.2-2.4,2.6
  c-0.6,0.2-1.2,0.2-1.8,0.3c-1.2,0.1-1.9,0.2-2.3,1c-0.3,0.7-0.1,1.8,0,2.8c0.1,0.7,0.2,1.4,0.2,1.9c-0.1,1.8-1.1,3-2.1,4.3
  l-0.4,0.4c-1.5,1.9-1.5,2.8-1.6,5.2c-0.2,3.4,0.1,6.2,1.7,9.5c0.6,1.3,1.6,2.2,2.7,3.3c1.5,1.4,3,2.9,3.4,5.3l0.1,0.4
  c0.3,1.6,0.4,2.1,1.8,2.1c0,0,0,0,0,0c0.4,0,0.9-0.1,1.3-0.2c0.7-0.1,1.4-0.3,1.9,0.1c0.5,0.4,0.7,1,0.8,2.1c0.1,1.3-0.5,2.4-1,3.3
  c-0.4,0.8-0.9,1.5-0.9,2.4c-0.1,1.5,1,2.2,2.9,3.1c0.3,0.2,0.6,0.3,0.9,0.5c0.6,0.3,1.2,0.6,1.8,0.9c2,0.9,4,1.8,5,4
  c0.8,1.6,1.5,4.1,1.5,5.9l1.9,2.3c0-1.1,0.1-2.2,1.5-2.8c1-0.4,2.1,0.1,3.1,0.6c0.5,0.2,1.2,0.6,1.4,0.4c0.1-0.1,0.1-0.3,0-0.4
  c-0.1-0.3-0.1-0.8,0.2-1.2c0.5-0.6,1.4-1.1,2-1.5l0.3-0.2c1.4-0.8,1.6-0.9,1.8-2.6c0.1-0.7,0-1.3-0.2-2c-0.1-0.6-0.2-1.2-0.2-1.9
  c0.1-1.2,0.6-2.2,1.1-3.1c0.1-0.2,0.2-0.4,0.3-0.6c1.4-2.6,3.2-6.3,3-9.5c0-0.8-0.3-1.5-0.5-2.2c-0.2-0.6-0.5-1.3-0.6-2.1
  c-0.1-1.1,0-2.3,0-3.5c0-0.8,0.1-1.5,0.1-2.2c0-2.4,0-4.7,0.1-7.1c0.1-2.8,0.1-5.6,0.1-8.5c0-1.5-0.2-3.1-0.3-4.6
  c-0.1-1.6-0.3-3.3-0.3-5c0-0.4,0-0.8,0-1.4c0-1.7,0-4.4,0-6.7c-1.6-1.2-2.4-3.7-2.4-6c0-0.1,0-0.1,0-0.2c-2.2,0-4.5,0.1-6.7,0.2
  C419.3,140,416.4,140.1,413.5,140.1z"
        />
        <path
          className="east-north-central"
          onClick={() => handleClickRegion("East North Central States")}
          d="M432.3,152.7c0,0.6,0,1,0,1.4c0,1.6,0.1,3.3,0.3,4.9c0.1,1.5,0.3,3.1,0.3,4.7c0,2.9,0,5.7-0.1,8.5
  c0,2.3-0.1,4.7-0.1,7c0,0.7,0,1.5-0.1,2.3c-0.1,1.2-0.1,2.4,0,3.4c0.1,0.6,0.3,1.2,0.5,1.8c0.3,0.8,0.6,1.5,0.6,2.5
  c0.2,3.4-1.7,7.4-3.1,10c-0.1,0.2-0.2,0.4-0.3,0.6c-0.5,0.9-1,1.7-1,2.7c0,0.2,0,0.3,0,0.5c0.2-0.1,0.4-0.3,0.6-0.4
  c0.9-0.7,2-1.5,2.9-1.6c0.5,0,0.9,0,1.2,0c0.6,0,1,0.1,1.7-0.3c0.4-0.2,0.7-0.5,1-0.7c0.6-0.5,1.2-0.9,2.4-1.1c0.6-0.1,1.2,0,1.8,0
  c0.7,0.1,1.3,0.1,1.8,0c0.6-0.2,0.8-0.5,1.1-0.9c0.3-0.4,0.6-0.9,1.4-1.2c1.4-0.6,1.9,0.1,2.4,0.6c0.2,0.3,0.4,0.5,0.8,0.7
  c0.8,0.4,1.4,0.5,1.8,0.4c0.5-0.2,0.8-1,1.2-1.9c0.2-0.4,0.4-0.9,0.6-1.4c0.6-1.3,1.3-1.8,2-2.3c0.3-0.2,0.7-0.5,1-0.8
  c0.6-0.5,0.8-1.3,1-2.1c0.2-0.8,0.4-1.6,0.9-2.1c1-1,2-0.9,2.7-0.8c0.8,0.1,1,0.1,1.3-0.9c0.5-1.7,0.6-4,0.6-5.6
  c0-4.4-0.7-9-1.4-13.5c-0.3-1.7-0.5-3.3-0.7-5c-0.3-2-0.3-4.1-0.4-6.2c-0.1-3.7-0.2-7.6-1.5-10.8c-0.2,0-0.4,0-0.6,0.1
  c-1.9,0.1-3.8,0.2-5.9,0.2c-4,0-8.1-0.3-12-1.3c-0.9,1.1-2.1,2-3.5,2.4c-1.2,0.4-2.3,0.3-3.1,0C432.4,148.7,432.4,151,432.3,152.7z
  "
        />
        <path
          className="east-north-central"
          onClick={() => handleClickRegion("East North Central States")}
          d="M456.8,144.1c3.1-0.2,5.9-0.7,8.8-1.3l1.1-0.2c1.1-0.2,4.1-0.2,6.5,0c0.2-3.1,1.5-6.4,2.1-9.6
  c0.4-2.3,0.9-2.1,2.1-3.8c1-1.3,0.6-2.7,0.5-4.5c-0.3-4.2-0.3-9.7-4.7-12.1c-2.3-1.3-2.4,0-3.2,1.6c-0.9,1.8-2.3,3.5-4,4.6
  c-2.4,1.6-2.6,0.6-2.8-2c-0.1-2.6,0.5-3.7,2.5-5c2-1.3,2.5-1.6,2.5-4.1c0-2.1,0.2-4.4,0-6.5c-0.6-6.7-7.2-2.9-10.5-6.8
  c-1.6-1.9-1.5-2.6-4.4-2.3c-2.2,0.2-3.1,0.8-3,3.2c-4.7,0.2-2.8,7.2-4.9,9.6c-1.4-0.8-2.2-2-3.2-3.2c-0.6,0.1-0.7,0.5-1.1,0.8
  c-0.9,0.9-1.6,4.3-2.1,5.5c-0.8,2-0.6,4-0.6,6.2c0,2,0.1,4-0.2,6c-0.3,2-0.9,3.3,0.4,5.1c1,1.5,3,2.5,3.7,4.3
  c0.7,1.8-0.1,4.3-0.3,6.1c-0.3,2.3-1,5.3-2.5,7.6C445.3,144.5,451.4,144.4,456.8,144.1z"
        />
        <text transform="matrix(1 0 0 1 409.2319 156.1486)" className="st9">
          <tspan x="0" y="0" className="st10 st7 st8">
            east north central
          </tspan>
          <tspan x="24" y="7.2" className="st10 st7 st8">
            states
          </tspan>
        </text>
        <text
          transform="matrix(1 0 0 1 401.0203 113.2599)"
          className="st6 st7 st8"
        >
          WI
        </text>
        <text
          transform="matrix(1 0 0 1 412.7557 174.8028)"
          className="st6 st7 st8"
        >
          IL
        </text>
        <text
          transform="matrix(1 0 0 1 448.8865 124.5499)"
          className="st6 st7 st8"
        >
          MI
        </text>
        <text
          transform="matrix(1 0 0 1 443.8699 173.7794)"
          className="st6 st7 st8"
        >
          IN
        </text>
        <text
          transform="matrix(1 0 0 1 476.2186 166.8014)"
          className="st6 st7 st8"
        >
          OH
        </text>
      </g>
      <g className="mid-atlantic-states-hover">
        <path
          className="mid-atlantic-states"
          onClick={() => handleClickRegion("MID atlantic States")}
          d="M509.1,134.2c0.3,0.1,1.4-0.2,1.9-0.3c0.5-0.1,0.9-0.2,1.2-0.3c0.9-0.1,1.7-0.1,2.6-0.2
  c1.7-0.1,3.5-0.3,5.2-0.5c6.9-0.8,12.3-1.6,17.9-3.5c1.1-0.4,2.3-0.8,3.4-1.3c1.6-0.6,3.3-1.3,4.9-1.8l0.1,0c1.2-0.3,3-0.8,4.2-0.6
  c1.3,0.2,2,0.9,2.7,1.7c0.2,0.2,0.4,0.4,0.6,0.6c0.3,0.3,0.6,0.6,1,0.9c1.3,1.1,3,2.5,3.9,3.9l0.4,0.1c4.6,1.6,8.4,2.3,12.9,1.4
  c-1-1.6-1.4-3.5-1.7-5.1c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.9-0.2-1.5-0.6-2.3c-0.3-0.5-0.7-0.9-1.1-1.3c-0.5-0.5-1.1-1.1-1.5-1.9
  c-1-2.4-1.4-5.9-1.2-10.8c0-0.4,0.1-0.9,0.2-1.6c0.3-2,0.8-5.4-0.3-6.6c-0.2-0.3-0.5-0.4-1-0.4h-0.5l0-0.5c-0.1-1.2,0-2.6,0.1-3.8
  c0.2-2.4,0.4-4.9-0.5-6.9c-0.4-0.8-0.8-1.2-1.3-1.7c-0.5-0.5-1.1-1-1.5-2.1c-0.6-1.8-0.4-3.8-0.3-5.8c0,0,0-0.1,0-0.1
  c-2,0.6-3.9,1.2-5.9,1.8c-2.6,0.8-6.2,0.9-8.5,2c-3.9,1.8-6.7,10-9.2,13.2c0.1,0.2,0.2,0.5,0,0c0.3,1,1.7,4.5,1.9,5.5
  c0.3,2-3.1,2.3-4.6,3.3c-2.1,1.4-3.9,3.2-6.2,4.3c-2.6,1.2-5.7,0.5-8.6,0.6c-2.5,0.1-4.6,0.9-6.3,2.8c-2.2,2.3,0.2,1.8,1,4.2
  c0.9,2.6-4.1,5.7-7.2,7.7C507.4,130.7,507.7,133.7,509.1,134.2z"
        />
        <path
          className="mid-atlantic-states"
          onClick={() => handleClickRegion("MID atlantic States")}
          d="M563.1,175.3c-0.7-0.2-1.3-0.3-2-0.5c-0.6-0.1-1.1-0.3-1.6-0.4c0,0,0,0,0,0c-0.9-2-2.1-5-2.3-6.4
  c-0.2-1.3-0.6-2.7-1-4c-0.3-0.9-0.6-1.9-0.8-2.8c-0.1-0.3-0.2-0.7-0.2-1c-0.3-1-0.5-2.1-0.7-3.1l0-0.4c0-0.1,0-0.2,0-0.4
  c-0.5,0.4-0.8,0.9-0.9,1.2h0c-5.7,1.1-12.8,2.8-18.8,4.6c0.6,0.2,1.2,0.5,1.8,0.9c0.5,0.3,0.8,0.8,1.2,1.2c0.4,0.5,0.7,0.9,1.3,1.2
  c0.4,0.2,0.9,0.2,1.5,0.1c0.7,0,1.4-0.1,2.1,0.3c2.1,0.9,3.1,2.6,4.1,4.3c0.3,0.6,0.7,1.2,1.1,1.8c1.7,2.4,2.5,2.6,5.7,2.9l0.3,0
  l0.5,0.9c0.5,0.9,1.5,2.5,2.4,3.7c0.5-0.1,1.1,0.2,2.1,0.5c1.8,0.6,2.3,0.5,2.1,2.8c-0.3,3.2-3.3,6.2-2,9.6c3,0.8,2.8-4.6,2.9-6.6
  c0.1-2.9,1.5-5.2,1.3-8.1C562.9,176.4,562.9,175.9,563.1,175.3z"
        />
        <path
          className="mid-atlantic-states"
          d="M501.8,142.3c0.9,4.3,1.6,9.2,2.2,15c0,0,0,0.1,0,0.1l0,0c2.3,2,2,4.1,1.6,6.3c-0.1,0.8-0.3,1.7-0.3,2.6
c4.2,0.2,8.6-0.4,13.4-1.8c0.4-0.1,1.2-0.4,2.1-0.8c4.5-1.8,9.1-3.6,11.2-2.6c0.3,0.2,0.6,0.4,0.8,0.7c6.4-1.9,13.5-3.3,19.8-4.5
c0.3-0.8,1.1-1.6,1.8-2c0.8-0.5,1.5-0.6,2.1-0.4v0c1.4-0.1,4-3,5.1-4.8c0.7-1.1,0-1.9-1.4-3.2c-0.4-0.3-0.7-0.7-1.1-1.1l-0.5-0.5
c-1.4-1.5-2.5-2.6-1.6-5.2c0.2-0.5,0.3-1,0.5-1.4c0.4-1.2,0.8-2.4,1-3.6c0-1.5-2.6-3.7-4.2-5c-0.4-0.4-0.8-0.7-1.1-0.9
c-0.2-0.2-0.5-0.4-0.7-0.7c-0.7-0.7-1.2-1.2-2.2-1.4c-1-0.2-2.7,0.3-3.8,0.6l-0.1,0c-1.6,0.4-3.2,1.1-4.8,1.7
c-1.1,0.4-2.3,0.9-3.5,1.3c-5.7,1.9-11.1,2.8-18.1,3.5c-1.7,0.2-3.5,0.3-5.2,0.5c-0.9,0.1-1.7,0.1-2.6,0.2c-0.2,0-0.6,0.1-1,0.2
c-0.8,0.2-1.5,0.4-2,0.4c-0.2,0-0.4,0-0.6-0.1c-1.8-0.7-2.2-3.6-2.3-6.2c-0.3,0.2-0.5,0.4-0.7,0.5c-1.7,1.5-3.4,2.8-5.2,4.1
c0.3,1.5,0.5,3.5,0.8,5.9C501.5,140.7,501.7,141.8,501.8,142.3z"
        />
        <path
          className="mid-atlantic-states"
          onClick={() => handleClickRegion("MID atlantic States")}
          d="M564.6,171.4c-1-2.2-3.6-3.9-4.3-6.3c-1.5-1.7-2.8-3.9-3.3-5.5c-0.1-0.5-0.1-1-0.1-1.6c0-1.3,0-2.1-0.7-2.4
  c-0.2-0.1-0.5,0-0.8,0.1c0,0.3,0.1,0.6,0.1,0.8l0,0.4c0.1,1,0.4,2,0.6,3c0.1,0.3,0.2,0.7,0.2,1c0.2,0.9,0.5,1.8,0.8,2.7
  c0.4,1.3,0.8,2.7,1,4.1c0.3,1.7,1,3.5,1.6,5.1c0.1,0.1,0.1,0.3,0.2,0.5c0.4,0.1,0.9,0.2,1.4,0.3c0.7,0.2,1.5,0.4,2.2,0.6
  c0.1-0.1,0.1-0.2,0.2-0.3C564.7,172.8,565.4,173.2,564.6,171.4z"
        />
        <path
          className="mid-atlantic-states"
          onClick={() => handleClickRegion("MID atlantic States")}
          d="M553.1,175.8c-3.2-0.2-4.3-0.7-6.2-3.3c-0.4-0.6-0.8-1.2-1.2-1.9c-1-1.6-1.8-3.1-3.6-3.9
  c-0.5-0.2-1-0.2-1.7-0.2c-0.7,0-1.3,0-2-0.2c-0.8-0.4-1.3-1-1.7-1.5c-0.3-0.4-0.6-0.7-0.9-1c-0.7-0.4-1.4-0.7-2.2-1
  c-0.2-0.1-0.4-0.2-0.6-0.2c0,0-0.1,0-0.1,0c0.1,0.6,0.7,1.1,1.3,1.6c0.7,0.6,1.4,1.2,1.4,2.1c0,0.5-0.2,0.9-0.6,1.4
  c-1.2,1.3-2.7,0.8-3.9,0.4c-0.7-0.2-1.3-0.4-1.9-0.4c0.3,1.9-1.3,4.1-2.5,5.7c-0.3,0.4-0.5,0.7-0.7,1c-0.3,0.5-0.8,1.4-1.3,2.3
  c-1.2,2.4-2.5,5.1-4,5.7c-0.8,0.3-1.5,0.1-2-0.1c-0.5-0.2-0.7-0.3-1.2,0.2c-0.6,0.5-1.2,1.9-1.8,3.1c-0.3,0.7-0.6,1.3-0.9,1.8
  c-2.1,3.4-3.2,6-3.5,9.9l0,0.3l-0.3,0.1c-0.4,0.2-0.8,0.3-1.2,0.4c-0.9,0.3-1.8,0.6-2.5,1.1c-0.3,0.2-0.4,0.4-0.6,0.7
  c-0.3,0.4-0.6,0.9-1.3,1.1c-0.5,0.2-1.1,0.1-1.6,0c-0.3-0.1-0.5-0.1-0.7-0.1c-0.9,0.1-1.4,0.5-2,1c-0.5,0.4-1,0.8-1.8,1.1
  c-0.5,0.2-1,0.3-1.4,0.3c-0.9,0-1.4-0.5-2.2-1.1l-0.4-0.4c-0.4-0.3-0.8-0.7-1.2-1.1c-0.7,0.6-1.5,1.6-2.1,2.5
  c-0.4,0.6-0.9,1.1-1.3,1.6c-0.7,0.8-1.5,1.6-2.5,2.5c-1.3,1.2-2.5,2.4-3.3,3.5c6.8-0.2,13.6-1.1,20.2-2.1c2.4-0.3,4.8-0.7,7.2-1
  c2.8-0.3,5.6-0.6,8.3-0.9c5.6-0.6,11.5-1.2,17.2-2.3c2-0.4,4.1-0.7,6-1c2.7-0.4,5.4-0.9,8.1-1.5c0.3-0.1,0.6-0.1,1-0.2
  c1.3-0.3,2.7-0.6,4.1-0.7c0.4,0,0.7,0,1.1,0c1,0,2.5-0.3,3.2-0.6c-0.5-1.3-1.2-2.7-1.5-3.7l-3,0.2c-0.3-1.4-1.8-2.3-2.1-3.6
  c-0.2-0.9-0.1-2.9-0.2-4c-0.2-2.4-0.2-6.4,0.8-8.5c0.1-0.3,0.2-0.4,0.4-0.6c-0.8-1.1-1.7-2.5-2.5-3.8L553.1,175.8z"
        />
        <path
          className="mid-atlantic-states"
          onClick={() => handleClickRegion("MID atlantic States")}
          d="M531.6,161.9c-1.8-0.9-7.4,1.4-10.4,2.6c-1,0.4-1.8,0.7-2.2,0.9c-4.3,1.2-8.4,1.8-12.3,1.8
  c-0.6,0-1.3,0-1.9-0.1l-0.5,0l0-0.4c-0.1-1.2,0.1-2.3,0.3-3.3c0.3-1.8,0.5-3.2-0.6-4.6c0,0.9-0.2,1.7-0.5,2.9
  c-0.2,0.9-0.4,1.9-0.5,2.8c-0.1,1-0.2,2-0.5,3c-0.5,1.9-2.2,3.2-3.8,4.4c-1.4,1.1-2.7,2.1-3.3,3.5c-0.1,0.3-0.2,0.6-0.3,1
  c-0.1,0.7-0.3,1.4-0.7,1.9c-0.4,0.5-1,0.6-1.3,0.6c-0.2,0-0.4,0.1-0.5,0.2c-0.7,0.6-0.9,1.5-1,2.6c-0.1,0.8-0.3,1.6-0.6,2.4
  c-0.7,1.5-1.4,2.5-2.3,2.8c-0.2,0.1-0.4,0.1-0.7,0.1c0,0.4-0.1,0.8-0.2,1.3c-0.1,0.8-0.3,1.6-0.2,2.3c0.2,1.4,1.1,2.4,2.1,3.6
  l0.1,0.2c2.2,2.7,4.3,4.8,6.4,6.5l0.4,0.4c1.1,0.9,1.4,1.1,2.6,0.7c0.6-0.2,1-0.6,1.5-0.9c0.7-0.5,1.4-1.1,2.5-1.2
  c0.3,0,0.7,0,1,0.1c0.4,0.1,0.8,0.2,1,0.1c0.4-0.2,0.6-0.4,0.8-0.8c0.2-0.3,0.4-0.6,0.8-0.9c0.8-0.6,1.8-0.9,2.8-1.3
  c0.3-0.1,0.6-0.2,0.9-0.3c0.3-3.9,1.5-6.5,3.6-10c0.3-0.4,0.5-1,0.8-1.7c0.6-1.3,1.3-2.7,2-3.4c0.9-0.8,1.6-0.6,2.2-0.4
  c0.4,0.1,0.8,0.3,1.3,0.1c1.1-0.4,2.5-3.2,3.5-5.2c0.5-1,0.9-1.9,1.3-2.4c0.2-0.3,0.5-0.7,0.8-1.1c1.2-1.6,2.8-3.7,2.2-5.3L528,167
  l0.5-0.2c1-0.4,2,0,3,0.3c1.3,0.4,2.2,0.6,2.9-0.1c0.2-0.2,0.3-0.4,0.3-0.6c0-0.4-0.5-0.9-1.1-1.3c-0.8-0.7-1.7-1.5-1.6-2.6
  C532,162.2,531.9,162,531.6,161.9z"
        />
        <path
          className="mid-atlantic-states"
          onClick={() => handleClickRegion("MID atlantic States")}
          d="M559.6,134.2c0,0.2,0,0.4-0.1,0.5v0l0,0c-0.2,1.4-0.6,2.6-1,3.9c-0.2,0.5-0.3,0.9-0.5,1.4
  c-0.6,2,0.1,2.8,1.4,4.2l0.5,0.5c0.3,0.4,0.7,0.7,1,1c1.3,1.2,2.7,2.6,1.6,4.5c-0.7,1.2-3,4.2-5,5.1c0.5,0.7,0.5,1.7,0.5,2.6
  c0,0.5,0,1,0.1,1.3c0.4,1.3,1.2,2.7,2.2,4.1c0,0,0,0,0,0c1.7-0.1,2.9,2.1,4.3,0.7c0.7-0.7,1.1-3.1,1.5-4.1c1.7-3.9,3.2-7.6,4-11.7
  c0.2-0.9,0.6-1.8,0.4-2.8c-0.2-1-1-1.4-1.3-2.3c-0.6-1.9,0.6-1.9,2.6-2.2c4.3-0.6,7.6-3,11.1-5.3c1.2-0.8,2.7-2.6,3.4-3.9
  c0.5-0.9,1.4-0.9-0.3-1.5c-0.8-0.3-1.7,0.1-2.3,0.4c-3.8,1.5-6.5,5.6-11.3,4.7C567.9,136.3,564,135.6,559.6,134.2z"
        />
        <text
          transform="matrix(0.9997 -2.636065e-02 2.636065e-02 0.9997 526.7523 162.7958)"
          className="st9"
        >
          <tspan x="0" y="0" className="st10 st7 st8">
            MID
          </tspan>
          <tspan x="-9.2" y="7.2" className="st10 st7 st8">
            Atlantic
          </tspan>
          <tspan x="-5.3" y="14.4" className="st10 st7 st8">
            states
          </tspan>
        </text>
        <text
          transform="matrix(1 0 0 1 528.9266 193.6012)"
          className="st6 st7 st8"
        >
          VA
        </text>
        <text
          transform="matrix(1 0 0 1 499.6385 183.3238)"
          className="st6 st7 st8"
        >
          WV
        </text>
        <text
          transform="matrix(1 0 0 1 579.7068 149.9063)"
          className="st6 st7 st8"
        >
          NJ
        </text>
        <text
          transform="matrix(1 0 0 1 584.8065 162.9542)"
          className="st6 st7 st8"
        >
          MD
        </text>
        <text
          transform="matrix(1 0 0 1 577.3963 172.1085)"
          className="st6 st7 st8"
        >
          DL
        </text>
        <text
          transform="matrix(1 0 0 1 540.1404 116.6534)"
          className="st6 st7 st8"
        >
          NY
        </text>
        <text
          transform="matrix(1 0 0 1 520.1204 150.6534)"
          className="st6 st7 st8"
        >
          PA
        </text>
        <line
          className="mid-atlantic-states"
          onClick={() => handleClickRegion("MID atlantic States")}
          x1="551.9"
          y1="166.2"
          x2="581.3"
          y2="161.7"
        />
        <line
          className="mid-atlantic-states"
          onClick={() => handleClickRegion("MID atlantic States")}
          x1="564.5"
          y1="170.8"
          x2="575.5"
          y2="170.5"
        />
      </g>
      <line
        className="mid-atlantic-states"
        onClick={() => handleClickRegion("MID atlantic States")}
        x1="567.5"
        y1="148"
        x2="578.5"
        y2="147.8"
      />
      <g className="mid-atlantic-states1-hover">
        <path
          className="mid-atlantic-states1"
          onClick={() => handleClickRegion("New England states")}
          d="M562.3,88.3c0.3,0.8,0.7,1.2,1.2,1.6c0.5,0.5,1.1,1,1.5,2c1,2.2,0.8,4.8,0.6,7.4c-0.1,1.2-0.2,2.3-0.1,3.3
  c0.5,0.1,0.9,0.3,1.2,0.7c1.3,1.5,0.8,5.1,0.5,7.4c0,0.3-0.1,0.5-0.1,0.7c1.3,0,2.4-0.5,3.7-1.1c1.4-0.6,2.8-1.3,4.3-1.1
  c0.2,0,0.3,0,0.5,0c-0.7-3.5-0.8-8-0.8-12c0-0.5-0.1-1.3-0.1-2c-0.2-2.2-0.4-4.7,0.4-6.1c0.7-1.3,2.5-1.7,3.7-1.9
  c0.1,0,0.1,0,0.2,0c-0.1-0.3-0.3-0.8-0.4-1.2c-0.5-1.4-1.2-3.1-0.5-4c0.2-0.2,0.4-0.4,0.9-0.5c0.1-1.3-0.2-3.1-0.6-4.9
  c-0.7,0.6-1.4,1.1-2.1,1.6c-2.5,1.6-5.9,1.8-8.7,2.8c-1.8,0.6-3.6,1.1-5.4,1.6c0,0.2,0,0.3,0,0.4C561.9,84.7,561.8,86.7,562.3,88.3
  z"
        />
        <path
          className="mid-atlantic-states1"
          onClick={() => handleClickRegion("New England states")}
          d="M584.5,107.6c-0.6,0.1-1.3,0.2-2,0.4c-0.8,0.2-1.6,0.6-2.4,0.9c-1.5,0.7-3,1.4-5,1.2c-1.3-0.1-2.5,0.4-3.8,1
  c-1.3,0.6-2.7,1.2-4.1,1.2c0,0-0.1,0-0.1,0c-0.2,4.7,0.2,8,1.1,10.2c0,0,0,0.1,0,0.1c3.4-0.8,6.7-2.1,9.8-3.4
  c2.5-1,5.2-2.1,7.8-2.9c1.7-0.5,4.2-1,6,0.7c0.8,0.8,1.4,2,1.9,3.1c0.3,0.6,0.6,1.3,0.9,1.9c0.6-0.1,1.5-0.1,1.8-0.3
  c0.7-0.3,0.9-1,1.6-1.1c1.9-0.4,2.8,1.1,4.4-1.1c0.4-0.6,1.2-1.4,0.7-2.1c-0.8-1.2-1.8,0.5-2.8,0.4c-1.9-0.2-1.6-2.3-2.5-3.8
  c-1.1-1.7-2.5-2.2-2.7-4.2c-0.2-1.8,0.1-2.7-1-4.5c-0.3-0.5-0.6-0.9-0.8-1.3c-1.7,0.2-3.2,0.8-4.5,1.8
  C587.4,107.2,586,107.4,584.5,107.6z"
        />
        <path
          className="mid-atlantic-states1"
          onClick={() => handleClickRegion("New England states")}
          d="M591.1,117.9c-1-1-2.5-1.1-4.8-0.5c0.1,1.3,0.5,2.7,1.1,4.1c0.3,0.8,0.7,1.7,0.9,2.6c0.1,0.3,0.2,0.7,0.3,1.1
  c0.1,0.5,0.2,1.1,0.4,1.6c1.5-0.4,3.1-1,3.8-1.8c0.7-0.8,0.5-1.6,1-2.3c-0.4-0.6-0.7-1.3-1-1.9
  C592.3,119.6,591.8,118.5,591.1,117.9z"
        />
        <path
          className="mid-atlantic-states1"
          onClick={() => handleClickRegion("New England states")}
          d="M617.9,63.7c-1.2,0.3-3.4,0.6-4.4-0.5c-0.7-0.7-0.5-2.9-1.5-3.6c-1-0.7-2.9,0.4-3.9-0.3c-1.3-0.9-0.9-3.6-1-5
  c-0.5-4.8,0.1-8.5-3.8-11.7c-2.2-1.8-2.6-2.8-5.3-1.8c-2.2,0.8-3.3,1.4-5.5,0.7c-1-0.3-0.8-1.2-2-0.7c-1,0.5-0.8,1.4-1,2.2
  c-0.5,1.9-0.8,4-1.1,6c-0.6,4.6-0.3,9.3-1,13.8c-0.3,2.1-1,4.2-2.1,6.1c-0.9,1.6-2,2.2-3.2,3.7c0,0.1-0.1,0.1-0.1,0.1
  c0.2,0.7,0.5,1.4,0.9,2.2l0.1,0.1c0.7,1.7,1.2,3.6,1.6,5.3c0.3,1.1,0.5,2.3,0.8,3.3c0.9,3,1.8,6.1,2.6,9.6c0.1,0.3,0.1,0.6,0.2,1.1
  c0.2,1.3,0.6,3.6,1.3,4.1c0.6,0.4,2.2,0.3,3.6,0.2c0.6-2.6,2.1-4.9,3.8-6.9c1.2-1.4,0.9-3.3,2.1-4.5c1.4-1.4,3-0.5,3.8-2.6
  c0.7-1.7,0.2-3.8,1.2-5.4c1.5-2.2,1.2,0.2,3.5,0.3c1.9,0.1,3-1.5,3.3-3c0.7-2.9,0.8-2.4,3.5-4.1C617.6,70.5,620.5,67.8,617.9,63.7z
  "
        />
        <path
          className="mid-atlantic-states1"
          onClick={() => handleClickRegion("New England states")}
          d="M588.7,99.3c-1-0.6-1.4-2.6-1.8-4.7c-0.1-0.4-0.1-0.8-0.2-1c-0.8-3.4-1.7-6.6-2.6-9.5
  c-0.3-1.1-0.6-2.3-0.9-3.4c-0.4-1.7-0.8-3.5-1.5-5.1l-0.1-0.1c-0.3-0.6-0.5-1.2-0.7-1.7c-0.6,0.7-1.2,1.4-1.9,2
  c0.6,2.2,0.9,4.6,0.7,6.2l-0.1,0.4l-0.5,0c-0.2,0-0.4,0-0.5,0.1c-0.3,0.5,0.3,2.1,0.7,3.1c0.4,1,0.6,1.6,0.5,2.1l-0.1,0.3l-0.3,0.1
  c-0.2,0.1-0.4,0.1-0.7,0.1c-1.1,0.2-2.5,0.5-3.1,1.4c-0.7,1.2-0.5,3.6-0.3,5.6c0.1,0.8,0.1,1.5,0.1,2.1c0,4,0.1,8.5,0.8,11.9
  c1.1-0.2,2-0.6,3-1.1c0.8-0.4,1.6-0.8,2.5-1c0.7-0.2,1.4-0.3,2.1-0.4c1.5-0.2,2.7-0.4,4-1.4c1.4-1.1,2.9-1.7,4.7-2
  c-0.2-0.5-0.4-1.1-0.4-1.8c0-0.6,0.1-1.1,0.1-1.6c-0.6,0-1.1,0.1-1.6,0.1C590.1,99.8,589.3,99.7,588.7,99.3z"
        />
        <path
          className="mid-atlantic-states1"
          onClick={() => handleClickRegion("New England states")}
          d="M587.3,124.3c-0.2-0.8-0.5-1.7-0.8-2.5c-0.5-1.3-1-2.7-1.1-4.1c-2.4,0.7-4.7,1.7-7,2.6
  c-3.1,1.3-6.3,2.5-9.6,3.3c0.2,0.2,0.4,0.4,0.6,0.6c0.5,0.4,0.9,0.9,1.3,1.5c0.5,0.9,0.6,1.8,0.7,2.7c0,0.3,0.1,0.5,0.1,0.8
  c0.2,1.6,0.6,3.3,1.5,4.8c2.7-4.6,8.8-4.6,13.4-6.4c0.4-0.2,0.9-0.3,1.5-0.5c-0.2-0.6-0.3-1.1-0.4-1.7
  C587.5,125,587.4,124.6,587.3,124.3z"
        />
        <text
          transform="matrix(0.9997 -2.636065e-02 2.636065e-02 0.9997 590.6932 81.5611)"
          className="st9"
        >
          <tspan x="0" y="0" className="st10 st7 st8">
            New England
          </tspan>
          <tspan x="12.8" y="7.2" className="st10 st7 st8">
            states
          </tspan>
        </text>
        <text
          transform="matrix(1 0 0 1 602.4061 149.9063)"
          className="st6 st7 st8"
        >
          CT
        </text>
        <text
          transform="matrix(1 0 0 1 603.3582 135.0777)"
          className="st6 st7 st8"
        >
          RI
        </text>
        <text
          transform="matrix(0.9601 -0.2797 0.2797 0.9601 579.9315 115.2355)"
          className="st6 st7 st8"
        >
          MA
        </text>
        <text
          transform="matrix(1 0 0 1 576.7811 100.5763)"
          className="st6 st7 st8"
        >
          NH
        </text>
        <text
          transform="matrix(1 0 0 1 594.1971 70.4718)"
          className="st6 st7 st8"
        >
          ME
        </text>
        <text
          transform="matrix(1 0 0 1 565.5496 89.4337)"
          className="st6 st7 st8"
        >
          VT
        </text>
        <line
          className="mid-atlantic-states"
          onClick={() => handleClickRegion("MID atlantic States")}
          x1="583.8"
          y1="124.1"
          x2="603.6"
          y2="144.2"
        />
        <line
          className="mid-atlantic-states"
          onClick={() => handleClickRegion("MID atlantic States")}
          x1="592.1"
          y1="124.1"
          x2="601.3"
          y2="134.1"
        />
      </g>
      <g>
        <path
          className="hi-states"
          d="M475.8,431.3c-0.8-0.8-1.2-1.8-2.5-1.9c-0.4-1.2,0.2-2.8-0.8-3.8c-1-1-3.5-1-4.8-1.3c-2.2-0.6-4.3-1.5-6.5-2.1
  c-1.2-0.4-4.7-2.7-5.1-3.8c-0.2,1.5-1.2,1.5-0.4,3.4c0.4,0.8,1.2,1.9,1.1,2.8c-0.1,1.4-1.4,1.3-2.3,2.1c-1.1,0.9-1.4,2.2-2.2,3
  c0.1,0,0.2,0,0.3,0.1c0.1,0.9,0.9,1.2,1.4,1.9c0.7,0.8,1.4,1.9,1.8,3c0.7,2.1,0.7,4.7,0.4,6.8c-0.1,1-1,4.1-0.4,5
  c0.4,0.6,2.1,0.5,2.8,0.9c0.9,0.5,2.2,1.1,3,1.7c2.5-0.7,2.8-5.9,5.6-6.7c1.3-0.4,2.2,0.2,3.6-0.5c1.3-0.6,2.1-1.6,3.3-2.3
  c1.2-0.7,5.1-2.5,5-4.3C479,434.3,476.2,431.8,475.8,431.3z"
        />
      </g>
      <text
        transform="matrix(1 0 0 1 461.3206 435.1783)"
        className="st6 st7 st8"
      >
        HI
      </text>
      <path
        className="ak-states"
        d="M106.7,450.5c0.2-0.6-0.2-1.2,0.1-1.8c0.2-0.6,1.3-1,1.6-1.5c1-1.5,0-2.2-0.6-3.7c-0.5-1.4-0.7-3.1-0.5-4.6
c0.3-2.8,0.2-5.6,0.6-8.3c0.3-1.4,0.2-3.2,0-4.6c-0.1-0.6-0.4-1.2-0.5-1.8c-0.2-1-0.1-0.7,0.2-1.8c0.5-1.6,0-1.9-1.6-2.4
c-1.1-0.4-2.5,0.1-3.5-0.3c-1.9-0.8-0.4-2-0.1-3.2c0.4-1.5-0.7-2.8-0.5-4.3c0.2-1.6,1.4-2-0.3-3c-0.6-0.3-1.1-0.3-1.7-0.8
c-0.5-0.4-0.8-1-1.3-1.4l36.9-37.9c-0.1-2.5,0.4-4.1-1.8-5.5c-1.8-1.1-2.2-1.9-2.6-3.8c-0.8-3.5-3.9-5-5.7-7.9
c-0.9-1.5-0.7-2-0.5-3.5c0.3-2-1.1-2.8-1.7-4.5c-0.4-1.1,0.3-2.2-0.1-3.5c-0.8-2.5-3.3-3.6-5.6-4.5c-2.6-1-5-2.2-7.7-3
c-0.8-0.3-2-0.8-2.9-0.4c-0.6,0.3-0.5,1.1-1.2,1.4c-1.2,0.5-3.1-1-3.5-2c-0.6-1.4-0.5-3.1-2.2-1.1c-1.2,1.4-3.1,3.9-3.6,5.6
c-0.4,1.5-0.1,3.2-0.3,4.7c-0.2,1.5,0.4,2.8,0.3,4.3c-0.2,2.1-1.3,1.1-2.7,0.3c-0.9-0.5-1.8-1-2.3-2c-0.4-0.9,0-1.9-0.8-2.8
c1.2-0.4,2.6-0.7,2.4-2.1c-0.2-1.2-2-2.3-2.8-3.1c-1.1-1.2-2.5-3.1-4-2.7c0.2,0-1.6,1-1.3,0.8c-0.7,0.6-0.4,0.4-0.8,1.4
c-0.6,1.8-1.3,1.8-2.9,2.6c-1.7,0.9-2.2,1.6-1.5,3.3c1.1,2.6,1.9,4.6,4.6,5.8c1,0.5,2.4,1.2,3.1,2.1c0.3,0.4,0.7,0.9,0.5,1.4
c-0.5,1-0.9,0.1-1.5,0.3c-1.2,0.4-1.6,1.7-2.9,2c-0.9,0.2-2.9,0-3.5-0.8c-0.3-0.4,0-1.1-0.5-1.6c-0.4-0.4-1.3-0.3-1.8-0.5
c-1.5-0.7-1-1.9-2-2.9c-1.5-1.4-6.6,0.1-8.5,0.5c-1.3,0.3-2.9,0-3.6,1.5c-1.1,2.2,0.5,2.8,1.8,4.2c-0.5,0.5-0.8,1.1-1.4,1.5
c-0.7-0.9-1.5-3.2-2.7-3.3c-1,0-1.8,3.1-2.2,4.3c-0.8,2.7,1.1,2.6,2.9,3.7c1,0.6,0.7,0.8-0.1,1.8c-0.6,0.8-1.4,1.5-2.1,2.1
c-1.4-1.9-1.9,0.4-2.9,1c-0.5,0.3-1.5-0.2-1.6,0.8c0,0.9,1.3,1.1,1.9,1.4c2.2,1,1.3,1.6,1.4,3.7c0.1,1.7,1.1,2.5,2.8,1.7
c0.5,1,1.1,2.1,1.8,3.1c-1,0.1-2,0.3-2.8,0.8c-0.9,0.5-1.3,1.7-2.1,2.1c-0.7,0.4-1.8-0.1-2.6-0.3c-1.2-0.1-2.3-0.2-3.5,0.1
c-1,0.2-1.3,0.7-2.2,0.1c-0.9-0.5-1.6-1.7-2.6-2.3c-1-0.6-1.7-1-2.8-1.2c-0.9-0.2-2-0.1-2.8-0.6c2.6-2.9-4.9-3.9-6.1-4.8
c-1.6-1.2-3.4-4.9-6-3.4c1.5,2,5.2,2.9,6.3,5.2c0.3,0.6-0.2,1.1,0.4,1.8c0.4,0.5,1.2,0.7,1.8,1c1.6,0.9,0.9,1.7,1.9,2.9
c1.6,1.9,5.2,2.2,7.2,3.5c0.5,0.3,0.9,0.7,1.5,0.9c1,0.3,0.7,0,1.6,0c0.8-0.1,0.6-0.3,1.5,0c0.6,0.2,1.2,0.7,1.7,1
c1.2,0.6,2.9,1.5,4.3,1.4c0.6,0,1.4-0.7,1.9-0.7c0.5,0,1,0.8,1.5,1c0.7,0.3,1.4,0.1,2.1,0.3c0.9,0.3,1.3,1.1,2.3,1.1
c1.1,0,2.3-0.8,3.4-0.7c-0.2-1.4-1-2.5,1-2.6c1.3-0.1,2.4,0.4,3.7,0.3c1.5-0.1,2.8-0.5,4.3,0c0.6,0.2,0.9,0.6,1.5,0.7
c0.7,0.1,1.6-0.2,2.3-0.2c1.3,0,5.4,2.1,4.2,3.8c-0.7,1-2-0.9-2.8-1.3c-0.9-0.5-2.3-0.4-3.3-0.2c-1,0.2-1.7,0.6-2.6,1
c-0.5,0.2-1.1-0.5-1.1,0.4c0,0.3,0.9,1.1,1.1,1.4c-0.7,0.8-5.9-1.8-5.5,0.4c0.1,0.3,2.8,1.6,3.2,1.7c1,0.3,2.6,0.6,3.6,0.7
c1,0.1,2.1-0.2,3.1,0.4s1.2,2,2,2.6c1.3,1,1.5,0.1,2.1-0.8c0.7-0.9,1.7-1.6,2.3-2.5c0.8,0.6,1.9,2,2,3.1c0.2,1.5-0.9,1.3-1.4,2.3
c-0.8,1.5,1.4,2.8,1.9,4.4c0.6,1.8,0.5,3.1,2.3,4.2c1.4,0.9,2.1,2.1,3.4,3c-0.4,0.8-0.6,1.9-0.1,2.6c0.7,1.1,1.7,0.6,2.6,1.4
c-1.3,2.6,1,4.6,0.6,7.4c-0.2,1.1-0.3,2,0,3.1c0.3,1.2,1.5,2.8,2.1,0.9c0.6,0.7,2.1,2.5,1.5,3.4c1.1,0.8,2,2.1,1.8,3.7
c-0.1,1.2-1.4,3.2-2.6,3.4c0.4,1.1,1.1,3,1.2,4.1c0.2,1.3-0.6,2.2-1,3.4c-0.4,1.2-0.5,1.9,0.4,2.9c0.5,0.5,2.3,1.1,1.2,2.4
c-0.4,0.5-1.2,0.1-1.6,0.5c-0.5,0.5-0.6,1.2-0.7,1.9c-0.3,1.5-0.5,2.3,1.3,2.7C104.6,451.8,106.2,451.9,106.7,450.5z"
      />

      <path
        className="hi-states"
        d="M33.6,372.1l-0.8-0.5c-0.5,0.5-1.7,0.5-0.6,1.3C32.9,373.4,34.1,373.1,33.6,372.1z"
      />
      <text
        transform="matrix(1 -4.636858e-03 4.636858e-03 1 92.8069 371.5749)"
        className="st6 st7 st8"
      >
        AK
      </text>
      <image
        style={{ overflow: "visible" }}
        width="1355"
        height="705"
        xlinkHref="B1FC7087.jpg"
        transform="matrix(1 0 0 1 523.2849 -762.617)"
      ></image>
      <g className="mountain-states-hover">
        <path
          className="mountain-states"
          onClick={() => handleClickRegion("Mountain States")}
          d="M155.9,38.2c-0.8,2.4-1.2,5-1.6,7.4c-0.3,1.7-0.6,3.5-1,5.2c-1.2,5.2-2.5,10.7-3.9,16.3
  c-0.7,2.9-0.8,5.4-0.3,7.7c0.2,0.7,0.6,1.3,1,1.9c0.5,0.7,1,1.4,1.1,2.3c0.3,1.8-1.2,3.4-2.4,4.6c-0.3,0.3-0.6,0.6-0.8,0.9
  c-1.3,1.5-2.3,3-3.4,4.6l-0.5,0.8c-0.3,0.4-0.9,1-1.4,1.5c-0.7,0.7-1.7,1.6-1.8,2.1c-0.1,0.4,0,0.5,0.2,0.8
  c0.1,0.2,0.3,0.4,0.5,0.7c0.1,0.2,0.2,0.3,0.3,0.4c0.3,0.3,0.5,0.6,0.5,1.5c0,0.5-0.2,1.1-0.4,1.7c-0.1,0.3-0.2,0.6-0.2,0.8
  c-0.5,2.3-1.1,4.7-1.9,7.3c-0.9,3.1-1.6,5.9-2,8.7c-0.2,1.2-0.5,2.5-0.9,3.7c-0.6,2-1.1,4-1,5.9c18.7,4.3,38.8,8.4,56.8,11.4
  l6.1-35c-0.2-0.2-0.4-0.3-0.5-0.4c-0.6-0.5-0.8-0.7-1.9-0.4c-0.8,0.2-1.3,0.6-1.9,1c-0.6,0.4-1.1,0.9-1.9,1.1
  c-0.4,0.1-0.8,0.2-1.1,0.2c-0.9,0-1.7-0.3-2.5-0.6c-0.5-0.2-1-0.4-1.6-0.5c-0.8-0.1-1.8,0.1-2.7,0.4c-1.3,0.3-2.6,0.7-3.7,0.2
  c-0.5-0.2-0.9-0.5-1-0.9c-0.3-0.6,0-1.3,0.3-1.9c0.2-0.5,0.4-0.9,0.4-1.4c0.1-1.8-1.3-4-2.3-5.6l-0.2-0.3c-0.7-1.2-1.5-2.3-2.4-3.3
  c-0.7-0.9-1.4-1.8-2-2.7c-0.8-1.2-1.3-1.4-2.4-1.6c-0.4-0.1-0.7-0.2-1.2-0.3l-0.3-0.1l0-0.3c-0.1-2.9,1.1-5.5,2.1-8.1
  c0.8-1.8,1.5-3.5,1.8-5.3c-5.9,0.8-7.3-5.2-8.4-9.6c-0.2-0.9-0.4-1.8-0.7-2.6c-0.3-1-0.8-2.1-1.3-3.2c-0.9-2-1.8-4-1.8-6
  c0-3.7,1.1-7.5,2.1-11.3c0.2-0.7,0.4-1.4,0.6-2l-7.4-1.6c-0.3,0.8-0.5,1.5-0.8,2.2C156.4,36.8,156.1,37.5,155.9,38.2z"
        />
        <path
          className="mountain-states"
          onClick={() => handleClickRegion("Mountain States")}
          d="M152.9,198.3l-3.3,16.2l-8.2-3.9V222c0.3,0.9,0.6,1.8,0.7,2.6c0.1,0.6,0.1,1.3,0.1,1.9c0,0.5,0,1,0,1.5
  c0,0.4,0.1,0.7,0.1,1.1c0,0.9,0.1,1.7,0.4,2.4c0.2,0.4,0.4,0.7,0.6,0.9c0.5,0.7,0.9,1.4,0.1,2.8c-0.6,1-1.4,1.9-2.1,2.7
  c-0.3,0.3-0.5,0.6-0.8,0.9c-0.9,1-1.4,2.4-1.9,3.7c-0.1,0.3-0.2,0.6-0.3,0.8c-0.7,1.9-1.3,3.3-2.7,4.8c-0.7,0.8-0.7,0.8-0.1,1.6
  c0.2,0.3,0.5,0.6,0.8,1.1c0.6,1.1,0.7,1.9,0.4,2.5c-0.4,0.8-1.3,1.1-2.2,1.3c-0.3,0.1-0.5,0.1-0.7,0.2l41.3,27.7h19l0-0.1
  l10.6-75.5L152.9,198.3z"
        />
        <path
          className="mountain-states"
          onClick={() => handleClickRegion("Mountain States")}
          d="M163.1,48.8c0,1.8,0.9,3.7,1.7,5.6c0.5,1.1,1,2.2,1.3,3.3c0.3,0.8,0.5,1.7,0.7,2.6c1.1,4.6,2.4,9.9,7.9,8.7
  l0.7-0.2l-0.1,0.7c-0.3,2.2-1.2,4.2-2,6.3c-1,2.4-2,4.8-2.1,7.4c0.3,0.1,0.6,0.2,0.8,0.2c1.2,0.3,1.9,0.5,2.9,2.1
  c0.6,0.9,1.3,1.8,1.9,2.7c0.8,1.1,1.7,2.2,2.4,3.4l0.2,0.3c1.1,1.7,2.5,4.1,2.4,6.2c0,0.6-0.3,1.2-0.5,1.8
  c-0.2,0.4-0.4,0.9-0.3,1.1c0.1,0.2,0.3,0.3,0.5,0.3c0.8,0.3,1.9,0,3-0.3c1.1-0.3,2.1-0.6,3.1-0.4c0.6,0.1,1.2,0.3,1.8,0.6
  c1,0.4,1.9,0.8,2.9,0.4c0.6-0.2,1.1-0.6,1.6-0.9c0.6-0.5,1.3-1,2.3-1.2c1.6-0.4,2.1,0,2.8,0.6c0,0,0,0,0,0l0.8-4.6l67,8.6l0.1-0.7
  l5.1-52.1l-13.7-1.2l-54.6-6l-38.1-8.3c-0.2,0.7-0.4,1.4-0.6,2.1C164.2,41.4,163.1,45.2,163.1,48.8z"
        />
        <polygon
          className="mountain-states"
          onClick={() => handleClickRegion("Mountain States")}
          points="224.2,282.2 222.5,278.9 264.1,282.1 269.4,212.7 205.4,207.3 194.8,282.7 200.5,282.7 206.6,279.3 
  224.1,282.5 224.1,282.2 	"
        />
        <polygon
          className="mountain-states"
          onClick={() => handleClickRegion("Mountain States")}
          points="267,105.1 200.9,96.6 193.8,136.8 193.8,148.6 262.5,156.3 	"
        />
        <polygon
          className="mountain-states"
          onClick={() => handleClickRegion("Mountain States")}
          points="282.2,159.6 212.9,151.8 205.6,206.1 282.2,212.7 	"
        />
        <path
          className="mountain-states"
          onClick={() => handleClickRegion("Mountain States")}
          d="M192.8,149.5v-12.3c-8.5-1.4-17.4-3-26.4-4.9l-13.4,65l51.5,8.7l7.2-54.4L192.8,149.5z"
        />
        <path
          className="mountain-states"
          onClick={() => handleClickRegion("Mountain States")}
          d="M106.1,118.7c-0.6,4.1-6.2,22.2-11.1,37.5l45.3,66.1v-13.1l8.5,4l16.6-81C144.8,128,123.6,123,106.1,118.7z"
        />
        <text
          transform="matrix(1 0 0 1 213.7552 69.8517)"
          className="st6 st7 st8"
        >
          MT
        </text>
        <text
          transform="matrix(1 0 0 1 164.5242 108.7628)"
          className="st6 st7 st8"
        >
          ID
        </text>
        <text
          transform="matrix(1 0 0 1 221.8001 127.0421)"
          className="st6 st7 st8"
        >
          WY
        </text>
        <text
          transform="matrix(1 0 0 1 125.5286 161.6407)"
          className="st6 st7 st8"
        >
          NV
        </text>
        <text
          transform="matrix(1 0 0 1 178.2982 173.0001)"
          className="st6 st7 st8"
        >
          UT
        </text>
        <text
          transform="matrix(1 0 0 1 240.2034 183.5309)"
          className="st6 st7 st8"
        >
          CO
        </text>
        <text
          transform="matrix(1 0 0 1 228.4344 241.5445)"
          className="st6 st7 st8"
        >
          NM
        </text>
        <text
          transform="matrix(1 0 0 1 166.0384 237.5445)"
          className="st6 st7 st8"
        >
          AZ
        </text>
        <text
          transform="matrix(1 0 0 1 179.3482 162.8599)"
          className="st6 st7 st8 st9 st10"
        >
          Mountain States
        </text>
      </g>
    </svg>
  );
};
export default SvgComponent;
